/*! SWE 4.4.0 2024012T1024 */
/*! For license information please see qg-main.js.LICENSE.txt */
(() => {
  (function($) {
    var t = {
        848: (t) => {
          "use strict";
          t.exports = {
            init: function () {
              (function($) {
                var t, e, n, a;
                !1 !== $("body").attr("data-qg-accessibility") &&
                  ((a = $("a[target=_blank]")).hasClass("qg-accessibility-off") ||
                    !1 === a.attr("data-access-extlink") ||
                    !1 === a.attr("data-access-new-window") ||
                    void 0 === a.attr("href") ||
                    (!1 === $.contains(".qg-blank-notice", a) && a.append(' <span class="qg-blank-notice sr-only">(Opens in new window)</span> '), void 0 === a.attr("title") && a.attr("title", "Opens in new window")),
                  (t = ":not(:has(.qg-blank-notice))"),
                  (e = $(".qg-correct".concat(t, ", table.qg-correct-incorrect td:nth-child(odd)").concat(t))),
                  (n = $(".qg-incorrect".concat(t, ", table.qg-correct-incorrect td:nth-child(even)").concat(t))),
                  e.prepend('<span class="qg-blank-notice sr-only">Correct.</span> '),
                  n.prepend('<span class="qg-blank-notice sr-only">Incorrect.</span> '));
              })(jQuery);
            },
          };
        },
        407: (t, e, n) => {
          "use strict";
          var a = n(861);
          !(function (t) {
            var e = [];
            t(".qg-featured .carousel.slide").each(function (n, a) {
              var i = t(a).attr("id");
              e.push(i),
                t(this).attr("data-state", "cycle"),
                t("#" + i)
                  .find(".toggleCarousel")
                  .on("click", function (e) {
                    e.preventDefault();
                    var n = t(this).parents("div.carousel.slide");
                    switch (n.attr("data-state")) {
                      case "pause":
                        n.attr("data-state", "cycle").carousel("cycle"), t(this).find("i, span").not(".button-title").removeClass("fa-sync fa-pause").addClass("fa-pause");
                        break;
                      case "cycle":
                        n.attr("data-state", "pause").carousel("pause"), t(this).find("i, span").not(".button-title").removeClass("fa-sync fa-pause").addClass("fa-sync");
                    }
                  });
            }),
              (window.onload = function () {
                !(function (e) {
                  e.forEach(function (e) {
                    var n = t("#" + e)
                      .find(".carousel-item")
                      .map(function (e, n) {
                        return t(n).height();
                      });
                    n.map(function (e, i) {
                      t(i).css("min-height", Math.max.apply(Math, a(n)) + "px");
                    });
                  });
                })(e);
              });
          })(jQuery);
        },
        898: () => {
          !(function (t) {
            "use strict";
            var e = t(".rc-theme");
            function n(e) {
              "focus" === e.type ? t(this).parents("li").addClass("rc-theme__focus") : t(this).parents("li").removeClass("rc-theme__focus");
            }
            if (e.length > 0) {
              var a = t('input[type="radio"]'),
                i = t('input[type="checkbox"]');
              e.find(a).on("change", function () {
                t(this).is(":checked") ? (t(this).parents(".rc-theme").find("li").removeClass("rc-theme__active"), t(this).parents("li").addClass("rc-theme__active")) : t(this).parents("li").removeClass("rc-theme__active");
              }),
                e.find(i).on("change", function () {
                  t(this).is(":checked") ? t(this).parents("li").addClass("rc-theme__active") : t(this).parents("li").removeClass("rc-theme__active");
                }),
                e.find(i).on("focus blur", n),
                e.find(a).on("focus blur", n);
            }
          })(jQuery);
        },
        854: () => {
          (function($) {
            0 === $("script[src*='jquery.fancybox']").length &&
              ($("[data-fancybox]").length > 0 || $(".qg-image-gallery").length > 0 || $(".qg-lightbox").length > 0 || $(".image-gallery").length > 0 || $('[class*="cut-in"]').length > 0) &&
              ($("head").append($("<link rel='stylesheet' href='https://static.qgov.net.au/assets/v4/latest/lib/ext/fancybox/jquery.fancybox.min.css' type='text/css' media='screen' />")),
              $.getScript("https://static.qgov.net.au/assets/v4/latest/lib/ext/fancybox/jquery.fancybox.min.js", function () {
                $(".qg-image-gallery, .image-gallery").each(function (t) {
                  $(this)
                    .find("a")
                    .each(function () {
                      $(this).is("[data-fancybox]") || $(this).attr("data-fancybox", "gallery-".concat(t)), $(this).is("[data-caption]") || $(this).attr("data-caption", $(this).attr("title"));
                    });
                });
                var t = $(".cut-in .caption a");
                $(t).attr("data-fancybox", "images"),
                  $('[data-fancybox^="gallery"]').fancybox({
                    buttons: ["thumbs", "close"],
                    mobile: {
                      preventCaptionOverlap: !1,
                      idleTime: !1,
                      clickSlide: function (t, e) {
                        return t.type, "close";
                      },
                    },
                    baseTpl:
                      '\n        <div class="fancybox-container" role="dialog" tabindex="-1">\n          <div class="fancybox-bg"></div>\n          <div class="fancybox-inner">\n                <div class="fancybox-infobar"><button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left p-0" title="Previous"><span class="font-awesome fa-2x fa-caret-left"></span></button><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span><button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right p-0" title="Next"><span class="font-awesome fa-2x fa-caret-right"></span></button></div>\n                <div class="fancybox-toolbar">{{buttons}}</div>\n                <div class="fancybox-navigation">{{arrows}}</div>\n                <div class="fancybox-stage"></div>\n                <div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>\n          </div>\n        </div>\n      ',
                    btnTpl: {
                      arrowLeft:
                        '\n          <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left p-0" title="{{PREV}}">\n            <span class="font-awesome fa-2x fa-caret-left"></span>\n          </button>\n        ',
                      arrowRight:
                        '\n           <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right p-0" title="{{NEXT}}">\n            <span class="font-awesome fa-2x fa-caret-right"></span>\n          </button>\n        ',
                    },
                    caption: function (t, e) {
                      var n = $(this).data("caption") || "";
                      return "image" === e.type && (n = '<div class="fancybox-border">' + (n.length ? n : "") + "</div>"), n;
                    },
                  });
              }));
          })(jQuery);
        },
        289: () => {
          document.addEventListener("DOMContentLoaded", function () {
            var t = /\.(?:PDF|DOC|DOCX|XLS|XLSX|RTF)$/i,
              e = /\((PDF|DOC|DOCX|XLS|XLSX|RTF)\s*,?\s*([\d.]+)\s*(KB|MB|GB)\)/i;
            document.querySelectorAll("#qg-primary-content a, #qg-secondary-content a").forEach(function (n) {
              var a = n.href.match(t),
                i = n.text.match(e);
              if (a && i) {
                var o = i[0],
                  r = i[1].toUpperCase(),
                  s = Math.ceil(parseFloat(i[2])),
                  c = i[3].toUpperCase(),
                  l = '<span class="meta">('.concat(r, ", ").concat(s, " ").concat(c, ")</span>");
                n.innerHTML = n.textContent.replace(o, l);
              }
            });
          });
        },
        253: (t, e, n) => {
          (function ($) {
            "use strict";
            n(114)().add($(".sticky")[0]);
            var t = $("#qg-content"),
              e = $(".qg-navigation");
            function a() {
              window.innerWidth > 991 ? $(".qg-portal-links button, .qg-portal-links a").attr("tabindex", "2") : $(".qg-portal-links button, .qg-portal-links a").attr("tabindex", "0");
            }
            $(".qg-show-menu, .qg-show-search").on("click", function () {
              var n = $(this).hasClass("qg-show-menu") ? $("#qg-global-search-form") : e;
              t.is(":hidden") && n.is(":hidden") ? t.show() : t.hide(),
                "false" === $(this).attr("aria-expanded") ? $("body").addClass("header-active") : $("body").removeClass("header-active"),
                $(this).hasClass("qg-show-menu")
                  ? $(".qg-search-form").collapse("hide")
                  : (setTimeout(function () {
                      $(".qg-search-form .input-group input[type=text]").focus();
                    }, 300),
                    e.collapse("hide"));
            }),
              a(),
              window.addEventListener("resize", function () {
                window.innerHeight < 991 && t.show(), a();
              });
          })(jQuery);
        },
        444: () => {
          !(function (t, e) {
            "use strict";
            var n = {
              url: "//creativecommons.org/licenses/",
              imgSrc: "https://static.qgov.net.au/assets/v4/latest/images/licences/",
              types: {
                by: { name: "Attribution", imgName: "by-80x15.png", versions: { "3.0": { title: "3.0 Australia (CC BY 3.0 AU)", urlPath: "by/3.0/au/" }, "4.0": { title: "4.0 International (CC BY 4.0)", urlPath: "by/4.0/" } } },
                "by-sa": {
                  name: "Attribution-ShareAlike",
                  imgName: "by-sa-80x15.png",
                  versions: { "3.0": { title: "3.0 Australia (CC BY-SA 3.0 AU)", urlPath: "by-sa/3.0/au" }, "4.0": { title: "4.0 International (CC BY-SA 4.0)", urlPath: "by-sa/4.0/" } },
                },
                "by-nd": {
                  name: "Attribution-NoDerivatives",
                  imgName: "by-nd-80x15.png",
                  versions: { "3.0": { title: "3.0 Australia (CC BY-ND 3.0 AU))", urlPath: "by-nd/3.0/au/" }, "4.0": { title: "4.0 International (CC BY-ND 4.0)", urlPath: "by-nd/4.0/" } },
                },
                "by-nc": {
                  name: "Attribution-NonCommercial",
                  imgName: "by-nc-80x15.png",
                  versions: { "3.0": { title: "3.0 Australia (CC BY-NC 3.0 AU)", urlPath: "by-nc/3.0/au/" }, "4.0": { title: "4.0 International (CC BY-NC 4.0)", urlPath: "by-nc/4.0/" } },
                },
                "by-nc-sa": {
                  name: "Attribution-NonCommercial-ShareAlike",
                  imgName: "by-nc-sa-80x15.png",
                  versions: { "3.0": { title: "3.0 Australia (CC BY-NC-SA 3.0 AU)", urlPath: "by-nc-sa/3.0/au/" }, "4.0": { title: "4.0 International (CC BY-NC-SA 4.0)", urlPath: "by-nc-sa/4.0/" } },
                },
                "by-nc-nd": {
                  name: "Attribution-NonCommercial-NoDerivatives",
                  imgName: "by-nc-nd-80x15.png",
                  versions: { "3.0": { title: "3.0 Australia (CC BY-NC-ND 3.0 AU)", urlPath: "by-nc-nd/3.0/au/" }, "4.0": { title: "4.0 International (CC BY-NC-ND 4.0)", urlPath: "by-nc-nd/4.0/" } },
                },
              },
            };
            document.getElementById("document-licence") ||
              t("meta")
                .filter('[name="DCTERMS.license"]')
                .filter(function () {
                  return new RegExp("https?://creativecommons.org/licenses/[a-zA-Z0-9\\-\\/\\.]+").test(this.content);
                })
                .eq(0)
                .each(function () {
                  var e = (function (t) {
                    var e = /\/licenses\/([a-zA-Z0-9-/.]+)/g
                        .exec(t)[1]
                        .split("/")
                        .filter(function (t) {
                          return t;
                        }),
                      a = e[0],
                      i = e[1];
                    return { name: n.types[a].name, url: n.url, imgPath: n.imgSrc + n.types[a].imgName, version: n.types[a].versions[i] };
                  })(this.content);
                  e &&
                    t(".qg-content-footer").append(
                      '<p id="document-licence"><a rel="license" href="' +
                        e.url +
                        e.version.urlPath +
                        '" title="Text available under Creative Commons ' +
                        e.name +
                        " " +
                        e.version.title +
                        ' licence"><img src="' +
                        e.imgPath +
                        '" alt="Creative Commons ' +
                        e.name +
                        " " +
                        e.version.title +
                        '" /></a></p>'
                    );
                });
          })(jQuery, qg);
        },
        484: () => {
          "use strict";
          !(function ($) {
            var t = { toggle: "false", hideOthers: "true" },
              e = { toggle: "data-toggle", hideOthers: "data-hide-others" },
              n = "data-qg-pr-parent",
              a = "data-qg-pr",
              i = "data-target",
              o = "data-parent",
              r = "qgProgressiveRevealActive";
            function s(n, a, i) {
              var o = e[i];
              $(n).attr(o) || (a.attr(o) ? $(n).attr(o, a.attr(o)) : $(n).attr(o, t[i]));
            }
            $("*[".concat(a, "]")).each(function () {
              var t = $("body");
              !$(this).attr(o) && $($(this).attr(i)).closest("*[".concat(n, "]")) && $(this).attr(o, "*[".concat(n, "]")), s(this, (t = $(this).closest($(this).attr(o))), "toggle"), s(this, t, "hideOthers");
            }),
              $("*[".concat(a, "]")).on("click", function () {
                var t = $($(this).attr(i));
                if (($(this).data(r, !0), $(this).toggleClass("toggle-active"), $(this).attr(o))) {
                  var n = $(this).closest($(this).attr(o));
                  n.length &&
                    (function (t, n) {
                      "false" !== $(t).attr(e.hideOthers) &&
                        n.find("*[".concat(a, "]")).each(function () {
                          !0 !== $(this).data(r) && $($(this).attr(i)).is(":visible") && $($(this).attr(i)).slideUp();
                        });
                    })(this, n);
                }
                "true" === $(this).attr(e.toggle) ? t.slideToggle() : t.is(":visible") || t.slideDown(), $(this).removeData(r);
              });
          })(jQuery);
        },
        992: () => {
          !(function (t) {
            "use strict";
            var e = [
              { property: 'meta[property="og:title"]' },
              { property: 'meta[property="og:description"]' },
              { property: 'meta[property="og:url"]' },
              { property: 'meta[property="og:type"]' },
              { property: 'meta[property="og:image"]' },
              { property: 'meta[name="twitter:card"]' },
              { property: 'meta[name="twitter:title"]' },
              { property: 'meta[name="twitter:description"]' },
              { property: 'meta[name="twitter:image"]' },
            ];
            (function () {
              var n = t('meta[name="DCTERMS.description"]').attr("content", "");
              t.each(e, function (e, a) {
                var i = t(a.property);
                i.length > 0
                  ? ("" !== i.attr("content") && void 0 !== i.attr("content")) ||
                    (("og:title" !== i.attr("property") && "twitter:title" !== i.attr("name")) || i.attr("content", document.title),
                    ("og:description" !== i.attr("property") && "twitter:description" !== i.attr("name")) || (n.length > 0 && i.attr("content", n)),
                    ("og:image" !== i.attr("property") && "twitter:image" !== i.attr("name")) || i.attr("content", "/assets/v4/latest/images/coat-of-arms/coa-thumbnail.png"),
                    "og:url" === i.attr("property") && i.attr("content", window.location.href),
                    "og:type" === i.attr("property") && i.attr("content", "article"),
                    "twitter:card" === i.attr("name") && i.attr("content", "summary"))
                  : t("head").append(i);
              });
            })();
          })(jQuery);
        },
        398: () => {
          !(function () {
            var t = [
              ["find.search.qld.gov.au", "discover.search.qld.gov.au"],
              ["qld-gov", "qgov~sp-search"],
              ["qgov-content", "qgov~sp-content"],
              ["services-web", "qgov~sp-services"],
            ];
            function e(e) {
              var n = e;
              return (
                t.forEach(function (t) {
                  if (((n = n.replace(new RegExp(t[0], "g"), t[1])), e.includes(t[0]))) {
                    var a = t[1].includes("qgov~") ? '"'.concat(t[0], '" collection,') : '"'.concat(t[0], '"');
                    console.log("SWE/Funnelback notice:\nThis application contains a reference to ".concat(a, ' which is deprecated. It must be replaced with "').concat(t[1], '".\n'));
                  }
                }),
                n
              );
            }
            document.querySelectorAll("form[data-suggestions], form[data-results-url], div[data-centres], input[name=collection]").forEach(function (t) {
              if (t.hasAttribute("data-suggestions")) {
                var n = t.getAttribute("data-suggestions");
                t.setAttribute("data-suggestions", e(n));
              }
              if (t.hasAttribute("data-results-url")) {
                var a = t.getAttribute("data-results-url");
                t.setAttribute("data-results-url", e(a));
              }
              if (t.hasAttribute("data-centres")) {
                var i = t.getAttribute("data-centres");
                t.setAttribute("data-centres", e(i));
              }
              if ("collection" === t.getAttribute("name")) {
                var o = t.getAttribute("value");
                t.setAttribute("value", e(o));
              }
            });
          })();
        },
        937: () => {
          (function ($) {
            "use strict";
            var t = { fn: {}, vars: {} };
            $("#qg-search-query").hasClass("qg-search-site__input") || $("#qg-search-query").addClass("qg-search-site__input"),
              $("#qg-global-search-form").hasClass("qg-site-search__form") || $("#qg-global-search-form").addClass("qg-site-search__form"),
              (t.fn.inputEventHandler = function (e) {
                var n = e.type,
                  a = $(e.target),
                  i = e.keyCode,
                  o = a.val();
                switch (n) {
                  case "focus":
                    t.fn.onFocus(o, a);
                    break;
                  case "blur":
                    t.fn.onBlur(o, a);
                    break;
                  case "keydown":
                    t.fn.onKeydown(o, i, a);
                }
              }),
              (t.fn.onFocus = function (e, n) {
                var a = n.parent().find($(".qg-search-concierge-initial"));
                n.attr("aria-expanded", "true"), "" === e ? a.addClass("show") : t.fn.checkForSuggestions(e, n);
              }),
              (t.fn.onBlur = function (e, n) {
                n.parent().find($(".qg-search-close-concierge")).addClass("hide"), t.fn.closeConciergePanels(n);
              }),
              (t.fn.onKeydown = function (e, n, a) {
                var i = a.parent().find($(".qg-search-concierge-initial")),
                  o = a.parent().find($(".qg-search-concierge-help")),
                  r = a.parent().find($(".qg-search-close-concierge"));
                40 === n
                  ? (a.parents($(".qg-site-search__form")).attr("data-navindex", "0"), setTimeout($(".qg-search-concierge.show").find("a, button")[0].focus(), 300))
                  : "" !== e
                  ? (r.removeClass("hide"), t.fn.checkForSuggestions(e, a))
                  : (r.addClass("hide"), i.addClass("show"), o.removeClass("show")),
                  i.hasClass("show") || o.hasClass("show") ? a.attr("aria-expanded", "true") : a.attr("aria-expanded", "false");
              }),
              (t.fn.keyboardNavigation = function (t) {
                var e = $(this),
                  n = t.keyCode,
                  a = e.parents(".qg-site-search__form").find($(".qg-search-concierge.show")).find("a, button"),
                  i = e.parents(".qg-site-search__form").attr("data-navindex");
                40 === n && a.length > i - 1
                  ? (a[++i].focus(), e.parents(".qg-site-search__form").attr("data-navindex", i))
                  : 38 === n && (i > 0 ? (a[--i].focus(), e.parents(".qg-site-search__form").attr("data-navindex", i)) : e.parents(".qg-site-search__form").find($("input[type=text].form-control")).focus());
              }),
              (t.fn.clearInputField = function (e) {
                var n = e.target,
                  a = $(this).parent().find($(".qg-search-close-concierge"));
                $(this).parent().find($(".qg-search-site__input")).val(""), a.addClass("hide"), t.fn.closeConciergePanels(n);
              }),
              (t.fn.searchSuggestionClick = function (t) {
                var e = $(t.currentTarget).text();
                $(".qg-search-site__input").val(e);
              }),
              (t.fn.handleBodyClick = function (e, n) {
                var a = e.target;
                0 === $(e.target).closest("#qg-global-search-form").length && t.fn.closeConciergePanels(a);
              }),
              (t.fn.handleFocus = function (e) {
                t.fn.closeConciergePanels(e.target);
              }),
              (t.fn.searchSubmitHandler = function (e) {
                t.fn.closeConciergePanels(e.target);
              }),
              (t.fn.getExampleSuggestions = function (t) {
                return [
                  { key: "cancelled", disp: "cancelled", disp_t: "T", wt: "77.44", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancellation", disp: "cancellation", disp_t: "T", wt: "72.139", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancel", disp: "cancel", disp_t: "T", wt: "69.493", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancelling", disp: "cancelling", disp_t: "T", wt: "43.151", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancellations", disp: "cancellations", disp_t: "T", wt: "32.28", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancellation of membership", disp: "cancellation of membership", disp_t: "T", wt: "2.2", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancellation form", disp: "fill out this cancellation form", disp_t: "T", wt: "2", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancel a booking", disp: "cancel a booking", disp_t: "T", wt: "1.1", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancel a disability parking permit", disp: "cancel a disability parking permit", disp_t: "T", wt: "1", cat: "", cat_t: "", action: "", action_t: "S" },
                  { key: "cancelling your registration", disp: "cancelling your registration", disp_t: "T", wt: "1", cat: "", cat_t: "", action: "", action_t: "S" },
                ].filter(function (e) {
                  return -1 !== e.disp.indexOf(t.toLowerCase());
                });
              }),
              (t.fn.getExampleServices = function () {
                return {
                  response: {
                    resultPacket: {
                      query: "grants",
                      results: [
                        {
                          rank: 1,
                          title: "Grants and funding | Environment, land and water | Queensland Government",
                          collection: "qgov-web",
                          metaData: {
                            license: "https://creativecommons.org/licenses/by/4.0/",
                            r: "all",
                            c: "Grants and funding are available to support environmental programs in Queensland. This includes koala and marine life conservation, and nature refuges.",
                            C: "Grants and funding are available to support environmental programs in Queensland. This includes koala and marine life conservation, and nature refuges.",
                            s:
                              "Grant; funding; nature assist; koala; Everyones environment; Indigenous sea rangers; research; NatureAssist; Indigenous Sea Country Management Grants Program; Koala Rescue and Rehabilitation Grants Program; Koala Research Grant Program; koala",
                            d: "2019-07-31",
                            t: "Grants and funding | Environment, land and water | Queensland Government;Grants and funding | Environment and pollution management",
                            e: "Text",
                            f: "guidelines",
                            j: "https://www.qld.gov.au/environment/pollution/funding",
                          },
                          liveUrl: "https://www.qld.gov.au/environment/pollution/funding",
                          clickTrackingUrl:
                            "/s/redirect?collection=qld-gov&url=https%3A%2F%2Fwww.qld.gov.au%2Fenvironment%2Fpollution%2Ffunding&index_url=https%3A%2F%2Fwww.qld.gov.au%2Fenvironment%2Fpollution%2Ffunding&auth=qzUXw9sTwPwOdKvslCPbog&profile=qld_preview&rank=1&query=grants",
                          explain: null,
                          indexUrl: "https://www.qld.gov.au/environment/pollution/funding",
                        },
                        {
                          rank: 2,
                          title: "Funding and grants | Recreation, sport and arts | Queensland Government",
                          collection: "qgov-web",
                          metaData: {
                            c: "Find what funding and grants are available for young athletes and for clubs to upgrade sport and recreation facilities or equipment.",
                            C: "Find what funding and grants are available for young athletes and for clubs to upgrade sport and recreation facilities or equipment.",
                            sprequired: "yes",
                            d: "2019-07-19",
                            e: "Collection",
                            f: "index",
                            stype: "apply-for-it",
                            j: "https://www.qld.gov.au/recreation/sports/funding",
                            sid: "P001085",
                            sfinder: "yes",
                            license: "https://creativecommons.org/licenses/by/4.0/",
                            scategory: "recreation-sports-and-arts",
                            r: "all",
                            s:
                              "Funding and grants; funding for young athletes; grants for young athletes; athlete scholarships; funding for kids and young people; funding for clubs and organisations; grants for clubs and organisations; funding to upgrade sport and recreation",
                            t: "Funding and grants | Recreation, sport and arts | Queensland Government;Funding and grants | Sport",
                            skioskonly: "no",
                          },
                          liveUrl: "https://www.qld.gov.au/recreation/sports/funding",
                          clickTrackingUrl:
                            "/s/redirect?collection=qld-gov&url=https%3A%2F%2Fwww.qld.gov.au%2Frecreation%2Fsports%2Ffunding&index_url=https%3A%2F%2Fwww.qld.gov.au%2Frecreation%2Fsports%2Ffunding&auth=cM3gwHE6wlGI5UzFw2iszA&profile=qld_preview&rank=2&query=grants",
                          explain: null,
                          indexUrl: "https://www.qld.gov.au/recreation/sports/funding",
                        },
                        {
                          rank: 3,
                          title: "Everyones Environment grants program | Environment, land and water | Queensland Government",
                          collection: "qgov-web",
                          metaData: {
                            c: "This program provides funding for Queensland community groups with projects aimed at delivering practical actions for local environmental improvements.",
                            C: "This program provides funding for Queensland community groups with projects aimed at delivering practical actions for local environmental improvements.",
                            sprequired: "no",
                            d: "2015-03-23",
                            e: "Text",
                            f: "guidelines",
                            stype: "find-it",
                            j: "https://www.qld.gov.au/environment/pollution/funding/everyones",
                            sid: "P000369",
                            sfinder: "yes",
                            license: "https://creativecommons.org/licenses/by/4.0/",
                            scategory: "environment-land-and-water",
                            r: "all",
                            s: "Grants; everyone; environment; heritage; Queensland; funding",
                            t: "Everyones Environment grants program | Environment, land and water | Queensland Government;Everyones Environment grants program | Grants and funding",
                            skioskonly: "no",
                          },
                          liveUrl: "https://www.qld.gov.au/environment/pollution/funding/everyones",
                          clickTrackingUrl:
                            "/s/redirect?collection=qld-gov&url=https%3A%2F%2Fwww.qld.gov.au%2Fenvironment%2Fpollution%2Ffunding%2Feveryones&index_url=https%3A%2F%2Fwww.qld.gov.au%2Fenvironment%2Fpollution%2Ffunding%2Feveryones&auth=QaZNQYwacyhU7xtVcs%2FPbg&profile=qld_preview&rank=3&query=grants",
                          explain: null,
                          indexUrl: "https://www.qld.gov.au/environment/pollution/funding/everyones",
                        },
                      ],
                      error: null,
                    },
                    curator: {
                      exhibits: [
                        {
                          titleHtml: "Queensland Government Grants Finder",
                          displayUrl: "https://www.grants.services.qld.gov.au/#/",
                          linkUrl:
                            "/s/redirect?collection=qld-gov&url=https%3A%2F%2Fwww.grants.services.qld.gov.au%2F%23%2F&index_url=https%3A%2F%2Fwww.grants.services.qld.gov.au%2F%23%2F&auth=wEzza0HDD%2BGN4WIzBUq0%2Fg&profile=qld_preview&type=FP",
                          descriptionHtml: "The Queensland Government Grants Finder is a comprehensive list of our grants and funding programs.",
                          additionalProperties: { icon: "fa-car fa-motorcycle fa-address-card", buttonText: "Find out more", service: "yes" },
                          category: "",
                        },
                        {
                          titleHtml: "North Queensland flood assistance",
                          displayUrl: "https://www.qld.gov.au/community/disasters-emergencies/queensland-disasters/fnq-monsoonal-trough",
                          linkUrl:
                            "/s/redirect?collection=qld-gov&url=https%3A%2F%2Fwww.qld.gov.au%2Fcommunity%2Fdisasters-emergencies%2Fqueensland-disasters%2Ffnq-monsoonal-trough&index_url=https%3A%2F%2Fwww.qld.gov.au%2Fcommunity%2Fdisasters-emergencies%2Fqueensland-disasters%2Ffnq-monsoonal-trough&auth=qbavFamsPcqvWK5M3INRmA&profile=qld_preview&type=FP",
                          descriptionHtml: "Personal hardship financial assistance has been activated for some communities at this time.",
                          additionalProperties: {},
                          category: "",
                        },
                        {
                          titleHtml: "Change of address",
                          displayUrl: "https://www.change-of-address.services.qld.gov.au/",
                          linkUrl:
                            "/s/redirect?collection=qld-gov&url=https%3A%2F%2Fwww.change-of-address.services.qld.gov.au%2F&index_url=https%3A%2F%2Fwww.change-of-address.services.qld.gov.au%2F&auth=RrjhEMq01%2B%2BZwQhpwXAjPg&profile=qld_preview&type=FP",
                          descriptionHtml: "Use this online form to change your home and/or postal address online, rather than contacting multiple Queensland Government departments/services.",
                          additionalProperties: { icon: "fa-car fa-motorcycle fa-address-card", service: "yes" },
                          category: "",
                        },
                      ],
                    },
                  },
                };
              }),
              (t.fn.closeConciergePanels = function () {
                var t = $(".qg-search-concierge-initial"),
                  e = $(".qg-search-concierge-help"),
                  n = $(".qg-search-site__input");
                t.addClass("hide").removeClass("show"),
                  e.addClass("hide").removeClass("show"),
                  n.attr("aria-expanded", "false"),
                  setTimeout(function () {
                    t.removeClass("hide"), e.removeClass("hide");
                  }, 300);
              }),
              (t.fn.checkForSuggestions = function (e, n) {
                var a = n.parent().find($(".qg-search-concierge-initial")),
                  i = n.parent().find($(".qg-search-concierge-help")),
                  o = e.length;
                a.removeClass("show"), o >= 3 && (t.fn.getSuggestions(e, n), t.fn.getServices(e, n), i.addClass("show"));
              }),
              (t.fn.getSuggestions = function (e, n) {
                var a = n.parents(".qg-site-search__form").attr("data-suggestions");
                $.ajax({
                  cache: !0,
                  dataType: "json",
                  url: a,
                  data: { partial_query: e },
                  success: function (e) {
                    t.fn.formatSuggestions(e, n);
                  },
                });
              }),
              (t.fn.formatSuggestions = function (t, e) {
                var n = e.parent().find($(".qg-search-site__input")).val(),
                  a = e.parent().find($(".qg-search-concierge-help .qg-search-concierge-group.suggestions")),
                  i = "";
                t.length > 0
                  ? (e.parent().find($(".qg-search-concierge-help")).show(),
                    (t = t.slice(0, 3)),
                    (i += '<div class="qg-search-concierge-content">'),
                    (i += "<h4>Suggestions</h4>"),
                    (i += '<ul class="list-group">'),
                    t.forEach(function (t) {
                      var e, a, o, r, s;
                      (i += '<li class="list-group-item">'),
                        (i += '<button tabindex="-1" data-analytics-link-group="qg-global-search-suggestion">'),
                        (i += ((e = n), (a = t.disp), (o = a.indexOf(e.toLowerCase())), (r = a.substr(o, e.length)), (s = "<b>"), (s += r), (s += "</b>"), a.replace(r, s))),
                        (i += "</button>"),
                        (i += "</li>");
                    }),
                    (i += "</ul>"),
                    (i += "</div>"))
                  : (e.parent().find($(".qg-search-concierge-help")).hide(), e.attr("aria-expanded", "false")),
                  a.html(i);
              }),
              (t.fn.getServices = function (e) {
                var n = $("#qg-global-search-form").attr("data-results-url");
                $.ajax({ cache: !0, dataType: "json", url: n, data: { query: e }, success: t.fn.processServices });
              }),
              (t.fn.processServices = function (e) {
                var n = e.response.resultPacket.results,
                  a = [],
                  i = null,
                  o = e.response.curator;
                if (void 0 !== o) {
                  var r = o.exhibits;
                  if (void 0 !== r && r.length > 0) {
                    i = r[0];
                    for (var s = 1; s < r.length; s++) {
                      var c = r[s];
                      "yes" === c.additionalProperties.service && a.push(c);
                    }
                  }
                }
                if (n.length > 0) {
                  var l = n.filter(function (t) {
                    return null != t.listMetadata && null != t.listMetadata.sfinder && "yes" === t.listMetadata.sfinder[0];
                  });
                  (a = a.concat(l)).length > 3 && (a = a.slice(0, 3));
                }
                t.fn.formatFeaturedService(i), t.fn.formatServices(a);
              }),
              (t.fn.formatFeaturedService = function (t) {
                var e = $(".qg-search-concierge-help .qg-search-concierge-group.highlight"),
                  n = "";
                if (t) {
                  var a = t.titleHtml,
                    i = t.displayUrl,
                    o = t.descriptionHtml,
                    r = t.additionalProperties;
                  if (((n = '<div class="qg-search-concierge-content">'), (n += '<div class="d-flex justify-content-between align-content-center flex-wrap">'), (n += "<h4>" + a + "</h4>"), void 0 !== r.icon))
                    n +=
                      "<div>" +
                      r.icon
                        .split(" ")
                        .map(function (t) {
                          return '<span class="fa ' + t + '"></span>';
                        })
                        .join("") +
                      "</div>";
                  (n += "</div>"),
                    (n += "<p>" + o + "</p>"),
                    i &&
                      (r.buttonText
                        ? (n += '<a href="' + i + '"  tabindex="-1" data-analytics-link-group="qg-global-search-feature" class="btn btn-global-primary-white">' + r.buttonText + "</a>")
                        : (n += '<a href="' + i + '"  tabindex="-1" data-analytics-link-group="qg-global-search-feature" class="btn btn-global-primary-white">Continue</a>')),
                    (n += "</div>");
                }
                e.html(n);
              }),
              (t.fn.formatServices = function (t) {
                var e = $(".qg-search-concierge-help .qg-search-concierge-group.helper"),
                  n = "";
                t.length > 0 &&
                  ((n = '<div class="qg-search-concierge-content">'),
                  (n += "<h4>Related services</h4>"),
                  (n += '<ul class="list-group">'),
                  t.forEach(function (t) {
                    var e = t.title,
                      a = t.liveUrl;
                    (e = void 0 !== e ? e.split("|")[0].trim() : t.titleHtml),
                      void 0 === a && (a = t.displayUrl),
                      (n += '<li class="list-group-item">'),
                      (n += '<a href="' + a + '" tabindex="-1" data-analytics-link-group="qg-global-search-related-service">' + e + "</a>"),
                      (n += "</li>");
                  }),
                  (n += "</ul>"),
                  (n += "</div>")),
                  e.html(n);
              }),
              $(document).ready(function () {
                var e, n, a, i;
                $(".qg-search-site__input").on(
                  "focus keydown",
                  ((e = t.fn.inputEventHandler),
                  (n = 200),
                  function () {
                    var t = this,
                      o = arguments,
                      r = a && !i;
                    clearTimeout(i),
                      (i = setTimeout(function () {
                        (i = null), a || e.apply(t, o);
                      }, n)),
                      r && e.apply(t, o);
                  })
                );
              }),
              $("body").on("focusin", ".qg-navigation .nav-link, .qg-service-finder__popular-apps a, .qg-coat-of-arms a", t.fn.handleFocus),
              $("body").on("click", t.fn.handleBodyClick),
              $("body").on("click", ".qg-search-close-concierge", t.fn.clearInputField),
              $("body").on("click", ".qg-search-concierge-group.suggestions button", t.fn.searchSuggestionClick),
              $("body").on("submit", "#qg-global-search-form", t.fn.searchSubmitHandler),
              $("body").on("keydown", ".qg-search-concierge-group a, .qg-search-concierge-group button", t.fn.keyboardNavigation);
          })(jQuery);
        },
        146: () => {
          !(function (t) {
            "use strict";
            ({
              config: { $twitterEl: t(".qg-twitter-updates"), $facebookEl: t(".qg-facebook-updates") },
              init: function () {
                var e = "platform.twitter.com/widgets.js",
                  n = "connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v12.0";
                this.config.$twitterEl.length > 0 && t('script[src*="' + e + '"]').length <= 0 && this.loadScript("script", "twitter-wjs", e),
                  this.config.$facebookEl.length > 0 &&
                    t('script[src*="' + n + '"]').length <= 0 &&
                    (this.config.$facebookEl.each(function () {
                      var e = t(this),
                        n = '<div class="fb-page" data-href="' + e.attr("data-href") + '" data-tabs="timeline" data-small-header="true" data-width="10000"  data-adapt-container-width="true" data-show-facepile="false"></div>';
                      e.append(n);
                    }),
                    this.loadScript("script", "facebook-wjs", n));
              },
              loadScript: function (t, e, n) {
                var a,
                  i = document.getElementsByTagName(t)[0],
                  o = /^http:/.test(document.location) ? "http" : "https";
                document.getElementById(e) || (((a = document.createElement(t)).id = e), (a.src = "".concat(o, "://").concat(n)), i.parentNode.insertBefore(a, i));
              },
            }.init());
          })(jQuery);
        },
        962: () => {
          !(function (t) {
            "use strict";
            var e, n;
            (e = t("#qg-primary-content table")).width() > t("#qg-primary-content").width() && e.wrap('<div class="scrollable"><div class="inner"></div></div>'),
              t(".scrollable").length > 0 &&
                (t(".scrollable").addClass("scrollable-table"),
                (n = function () {
                  t(".scrollable-table").removeClass("scrollable");
                }),
                window.matchMedia("print").addListener(function (t) {
                  return t.matches ? n() : null;
                }),
                window.addEventListener("beforeprint", function () {
                  return n();
                }),
                (window.onafterprint = function (e) {
                  setTimeout(function () {
                    t(".scrollable-table").addClass("scrollable");
                  }, 100);
                }));
          })(jQuery);
        },
        145: () => {
          (function($) {
            $(".qg-global-breadcrumb .qg-breadcrumb-list").each(function () {
              var t = $(this).find(".qg-breadcrumb-list-item").length;
              if (t > 4) {
                for (var e = 0; e < t; e++)
                  e > 1 && e < t - 2
                    ? ($(this).find(".qg-breadcrumb-list-item").eq(e).addClass("shortened"),
                      $(this).find(".qg-breadcrumb-list-item").eq(e).find(".qg-breadcrumb-list-item__link").attr("tabindex", "-1"),
                      $(this).find(".qg-breadcrumb-list-item").eq(e).find(".qg-breadcrumb-list-item__link").attr("data-analytics-link-group", "qg-breadcrumb-revealed-link"))
                    : $(this).find(".qg-breadcrumb-list-item").eq(e).find(".qg-breadcrumb-list-item__link").attr("data-analytics-link-group", "qg-breadcrumb-link");
                $(this)
                  .find(".qg-breadcrumb-list-item")
                  .eq(1)
                  .after("<li class='qg-breadcrumb-list-item shorten'><button class='qg-breadcrumb-toggle' aria-label='Expand the breadcrumbs' data-analytics-link-group='qg-breadcrumb-ellipsis'>[...]</button></li>");
              }
              $(".qg-breadcrumb-toggle").on("click", function () {
                $(".qg-breadcrumb-list-item").removeClass("shortened"), $(".qg-breadcrumb-list-item__link").attr("tabindex", "0"), $(".qg-breadcrumb-list").addClass("expanded");
              });
            });
          })(jQuery);
        },
        947: () => {
          (function ($) {
            "use strict";
            var t = ".qg-cut-in, .qg-cut-in-alt";
            $("#qg-content .figure-credits-toggle").on("click", function () {
              $(this).closest(t).find(".figure-credits").toggle(500).focus().end();
            }),
              $(t).length &&
                console.warn(
                  '".qg-cut-in" and ".qg-cut-in-alt" is going to be deprecated in SWE library. Please replace ".qg-cut-in" or ".qg-cut-in-alt" with ".qg-fig". Please refer to https://qld-gov-au.github.io/web-template-release/components/images.html for more details.'
                );
          })(jQuery);
        },
        562: () => {
          (function ($) {
            $(".qg-index-item").each(function () {
              $(this).find("img").length <= 0 && $(this).addClass("content-only");
            });
          })(jQuery);
        },
        119: () => {
          !(function (t) {
            t(".qg-share-link").each(function () {
              var e = window.location.href,
                n = window.location.hostname;
              t(this).hasClass("qg-share-facebook")
                ? t(this).attr("href", "http://www.facebook.com/share.php?u=".concat(e))
                : t(this).hasClass("qg-share-twitter")
                ? t(this).attr("href", "http://twitter.com/share?url=".concat(e))
                : t(this).hasClass("qg-share-linkedin") && t(this).attr("href", "http://www.linkedin.com/shareArticle?mini=true&url=".concat(e, "&source=").concat(n));
            });
          })(jQuery);
        },
        394: (t) => {
          var e = {
            init: function (t) {
              (function($) {
                $(".no-js").removeClass("no-js");

                var e = {
                    franchise: t || location.pathname.split("/")[1],
                    "page-title": $(document).find("title").text(),
                    "page-url": window.location.href,
                    "page-referer": document.referrer,
                    rspUsrAgent: navigator.userAgent,
                    browserName: this.predictBrowserName().name + " " + this.predictBrowserName().version,
                    OS: navigator.platform,
                    "g-recaptcha-response": ""
                };

                for (var n in e) {
                    this.addHiddenInput("".concat(n), "".concat(e[n]));
                }

                $(".qg-footer-feedback__close").on("click", function (t) {
                    t.preventDefault();
                    $(".qg-feedback-toggle").removeClass("d-none");
                });

                $(".qg-feedback-toggle").on("click", function (t) {
                    t.preventDefault();
                    $("#qg-page-feedback-form").hasClass("d-none") && $(this).addClass("d-none");
                });
            }).call(this, jQuery);
            },
            sanitize: function (t) {
              return !!t && t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\+/g, "&#43;").replace(/\\/g, "&#92;").replace(/\(/g, "&#40;").replace(/\)/g, "&#41;").replace(/{/g, "&#123;").replace(/}/g, "&#124;");
            },
            predictBrowserName: function () {
              var t,
                e = navigator.userAgent,
                n = e.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
              return /trident/i.test(n[1])
                ? { name: "IE", version: (t = /\brv[ :]+(\d+)/g.exec(e) || [])[1] || "" }
                : "Chrome" === n[1] && null != (t = e.match(/\bOPR|Edge\/(\d+)/))
                ? { name: "Edge", version: t[1] }
                : ((n = n[2] ? [n[1], n[2]] : [navigator.appName, navigator.appVersion, "-?"]), null != (t = e.match(/version\/(\d+)/i)) && n.splice(1, 1, t[1]), { name: n[0], version: n[1] });
            },
            addHiddenInput: function (t, e) {
                
                (function($) {
                    var n = $('<input type="hidden"/>');
                    n.attr("name", t);
                    n.attr("value", this.sanitize(e));
                    $("#feedback-hidden-inputs").append(n);
                }).call(this, jQuery);
            },
            resetForm: function () {
              function t() {
                $("#qg-page-feedback-form :input:not(:checkbox):not(:hidden):not(:button):not(:radio):not(:submit)").each(function () {
                  $(this).val("");
                }),
                  $("#qg-page-feedback-form :input:checkbox, #qg-page-feedback-form :input:radio").each(function (t) {
                    $(this).prop("checked", !1);
                  });
              }
              window.addEventListener(
                "load",
                function (e) {
                  t();
                },
                !1
              );
            },
          };
          t.exports = e;
        },
        267: () => {
          !(function (t) {
            t("#qg-copyright-daterange").length > 0 && t("#qg-copyright-daterange").html("1995&ndash;" + new Date().getFullYear());
          })(jQuery);
        },
        961: () => {
          (function ($) {
            "use strict";
            var t = {
              fn: {},
              vars: {
                cookie_name: "qg-location",
                event_coordinates_set: "qgLocationCoordsSet",
                event_locality_set: "qgLocationLocalitySet",
                event_location_found: "qgLocationFound",
                event_location_cleared: "qgLocationCleared",
                error_message: "",
                suburb_input: "",
              },
            };
            function e() {
              $(".header-location").removeClass("show"), $(".header-location .dropdown-toggle").attr("aria-expanded", "false"), $(".header-location .qg-location-setter").removeClass("show");
            }
            $(".header-location .dropdown-menu").click(function (e) {
              var n = event.target.tagName.toLowerCase();
              40 !== event.keyCode && 38 !== event.keyCode && t.fn.closeSuburbsIfOutside(e), "button" !== n && e.stopPropagation();
            }),
              (t.fn.getDeviceLocation = function (e) {
                e.stopPropagation(), navigator.geolocation && navigator.geolocation.getCurrentPosition(t.fn.processPositionData, t.fn.failure);
              }),
              (t.fn.deletePositionData = function (e) {
                e.stopPropagation(),
                  (function (t) {
                    document.cookie = t + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                  })(t.vars.cookie_name),
                  $("body").trigger("custom", t.vars.event_location_cleared);
              }),
              (t.fn.closeLocationPopup = function (t) {
                t.stopPropagation(),
                  e(),
                  $(".header-location .dropdown-menu").addClass("closed"),
                  setTimeout(function () {
                    $(".header-location .dropdown-menu").removeClass("closed");
                  }, 300);
              }),
              (t.fn.initManualSearch = function (e) {
                var n = e.target,
                  a = e.keyCode,
                  i = n.value.toLowerCase(),
                  o = i.length;
                $(".qg-location-setter-form input[type=text]").removeClass("error"),
                  40 === a
                    ? $(".qg-location-setter-autocomplete button").length && ($(".qg-location-setter-autocomplete button")[0].focus(), $(".qg-location-setter-form input[type=text]").attr("data-navindex", "0"))
                    : o >= 3
                    ? ((t.vars.suburb_input = i), t.fn.querySuburbsAPI())
                    : $(".qg-location-setter-autocomplete").addClass("hide");
              }),
              (t.fn.keyboardNavigation = function (t) {
                var e = parseInt($(".qg-location-setter-form input[type=text]").attr("data-navindex"));
                40 === t.keyCode
                  ? (e++, $(".qg-location-setter-autocomplete button")[e].focus())
                  : 38 === t.keyCode && (e > 0 ? (e--, $(".qg-location-setter-autocomplete button")[e].focus()) : $(".qg-location-setter-form input[type=text]").focus()),
                  $(".qg-location-setter-form input[type=text]").attr("data-navindex", e);
              }),
              (t.fn.getManualSuburbName = function (t) {
                t.stopPropagation();
                var e = t.target,
                  n = e.getAttribute("data-location"),
                  a = $(e).text(),
                  i = $(".qg-location-setter-form input[type=text]");
                i.attr("data-choice", n), i.attr("data-choice-full", a), i.val(a), $(".qg-location-setter-autocomplete").addClass("hide");
              }),
              (t.fn.setManualSuburb = function (n) {
                n.stopPropagation();
                var a = $(".qg-location-setter-form input[type=text]"),
                  i = $(".qg-location-setter-error");
                if (a.val().length > 2) {
                  i.addClass("hide");
                  var o = a.attr("data-choice"),
                    r = a.attr("data-choice-full");
                  "" === o ? (a.addClass("error"), i.removeClass("hide")) : (e(), t.fn.saveLocality(o, r));
                } else a.addClass("error"), i.removeClass("hide");
              }),
              (t.fn.locationSubmitHandler = function (t) {
                t.preventDefault();
              }),
              (t.fn.closePopupIfOutside = function (t) {
                $(t.target).closest("#qg-location-dropdown").length ||
                  $(t.target).is("#qg-location-dropdown") ||
                  $(t.target).is(".dropdown-toggle") ||
                  !$(".header-location .qg-location-setter").hasClass("show") ||
                  (e(),
                  $(".header-location .dropdown-menu").addClass("closed"),
                  setTimeout(function () {
                    $(".header-location .dropdown-menu").removeClass("closed");
                  }, 300));
              }),
              (t.fn.closeSuburbsIfOutside = function (t) {
                $(t.target).closest(".qg-location-setter-form").length || void 0 === t.view || $(".qg-location-setter-autocomplete").addClass("hide");
              }),
              (t.fn.getExampleLocation = function () {
                return [
                  {
                    address_components: [
                      { long_name: "Browning St near Boundary Rd, stop 5", short_name: "Browning St near Boundary Rd, stop 5", types: ["establishment", "point_of_interest", "transit_station"] },
                      { long_name: "South Brisbane", short_name: "South Brisbane", types: ["locality", "political"] },
                      { long_name: "Brisbane City", short_name: "Brisbane", types: ["administrative_area_level_2", "political"] },
                      { long_name: "Queensland", short_name: "QLD", types: ["administrative_area_level_1", "political"] },
                      { long_name: "Australia", short_name: "AU", types: ["country", "political"] },
                      { long_name: "4101", short_name: "4101", types: ["postal_code"] },
                    ],
                    formatted_address: "Browning St near Boundary Rd, stop 5, South Brisbane QLD 4101, Australia",
                    geometry: {
                      location: { lat: -27.477727, lng: 153.01314 },
                      location_type: "GEOMETRIC_CENTER",
                      viewport: { northeast: { lat: -27.4763780197085, lng: 153.0144889802915 }, southwest: { lat: -27.4790759802915, lng: 153.0117910197085 } },
                    },
                    place_id: "ChIJufdIyqBQkWsRlnW4qQxzN94",
                    types: ["establishment", "point_of_interest", "transit_station"],
                  },
                ];
              }),
              (t.fn.getExampleServiceCentres = function () {
                return {
                  question: { rawInputParameters: { origin: ["-27.477413799999997;153.01329099999998"] } },
                  response: {
                    resultPacket: {
                      results: [
                        {
                          rank: 1,
                          title: "Asif AMin Justices of the Peace Branch",
                          kmFromOrigin: 0.2,
                          metaData: {
                            area: "Brisbane City",
                            hours: "Monday to Friday, 10am-2pm|Mon,Mon,Tues,Tues,Wednes,Wednes,Thurs,Thurs,Fri,Fri,",
                            agency: "DJAG",
                            address2: "Level 6, 154 Melbourne Street",
                            address1: "See reception",
                            viewpageassetid: "21806",
                            postcode: "4101",
                            type: "Service",
                            s: "Volunteer Justice of the Peace or Commissioner for Declarations",
                            t: "Justices of the Peace Branch",
                            phone: "1300 301 147",
                            datasource: "JP",
                            suburb: "SOUTH BRISBANE",
                            location: "-27.4761712;153.0149019",
                            id: "92",
                          },
                        },
                        {
                          rank: 2,
                          title: "Family Court Brisbane",
                          kmFromOrigin: 1.2,
                          metaData: {
                            area: "Brisbane City",
                            hours: "Monday, Thursday and Friday 9am-2pm Note this service is for Family Court matters only. Hours of service may vary daily.|Mon,Mon,Thurs,Thurs,Fri,Fri,",
                            agency: "DJAG",
                            address2: "(Entrance via Tank Street)",
                            address1: "Corner North Quay and Tank Streets",
                            viewpageassetid: "21806",
                            postcode: "4000",
                            type: "Service",
                            s: "Hours of service vary daily, please phone before attending. Volunteer Justice of the Peace or Commissioner for Declarations",
                            t: "Family Court Brisbane",
                            datasource: "JP",
                            suburb: "BRISBANE",
                            location: "-27.468426;153.019921",
                            id: "62",
                          },
                        },
                      ],
                    },
                  },
                };
              }),
              (t.fn.queryLocationAPI = function (t, e) {
                new google.maps.Geocoder().geocode(t, function (t, n) {
                  "OK" === n ? e(t) : window.alert("Geocoder failed due to: " + n);
                });
              }),
              (t.fn.getLocality = function () {
                var e = t.fn.getStoredLocation(),
                  n = { location: { lat: parseFloat(e.latitude), lng: parseFloat(e.longitude) } };
                t.fn.queryLocationAPI(n, t.fn.processLocality);
              }),
              (t.fn.processLocality = function (e) {
                for (var n = "unknown", a = 0; a < e.length; a++) {
                  var i = e[a].address_components;
                  if ("unknown" !== n) break;
                  for (var o = 0; o < i.length; o++) {
                    var r = i[o];
                    if (-1 !== r.types.indexOf("locality")) {
                      n = r.short_name;
                      break;
                    }
                  }
                }
                "unknown" !== n && t.fn.saveLocality(n);
              }),
              (t.fn.getCoordinates = function () {
                var e = t.fn.getStoredLocation();
                if (void 0 === e.latitude) {
                  if (e.address) {
                    var n = { address: e.address };
                    t.fn.queryLocationAPI(n, t.fn.processCoordinates);
                  }
                } else $("body").trigger("custom", t.vars.event_location_found);
              }),
              (t.fn.processCoordinates = function (e) {
                for (var n = null, a = 0; a < e.length; a++) {
                  var i = e[a].geometry;
                  if (void 0 !== i && void 0 !== (n = i.location)) break;
                }
                null !== n && t.fn.saveCoordinates(n);
              }),
              (t.fn.querySuburbsAPI = function () {
                var e = { f: "json", where: "ADMINAREANAME+%3C%3E+%27Null%27", returnGeometry: "false", spatialRel: "esriSpatialRelIntersects", outFields: "ADMINAREANAME", orderByFields: "ADMINAREANAME%20ASC" },
                  n = "?";
                (n += Object.keys(e)
                  .map(function (t) {
                    return t + "=" + e[t];
                  })
                  .join("&")),
                  $.ajax({ cache: !0, dataType: "json", url: "https://gisservices.information.qld.gov.au/arcgis/rest/services/PlanningCadastre/LandParcelPropertyFramework/MapServer/19/query" + n, success: t.fn.processSuburbsData });
              }),
              (t.fn.processSuburbsData = function (e) {
                var n = [],
                  a = t.vars.suburb_input;
                Object.prototype.hasOwnProperty.call(e, "features") &&
                  e.features.forEach(function (t) {
                    var e,
                      i,
                      o,
                      r,
                      s = t.attributes.ADMINAREANAME || t.attributes.adminareaname,
                      c = (function (t) {
                        for (var e = t.toLowerCase().split(" "), n = 0; n < e.length; n++) e[n] = e[n].charAt(0).toUpperCase() + e[n].substring(1);
                        return e.join(" ");
                      })((s = s.toLowerCase())),
                      l = { name: s, name_friendly: c, name_formatted: c, suburb: c.split(",")[0] };
                    "" !== a ? 0 === s.indexOf(a) && ((l.name_formatted = ((e = a), (o = (i = c).substr(0, e.length)), (r = "<b>"), (r += o), (r += "</b>"), i.replace(o, r))), n.push(l)) : n.push(l);
                  }),
                  t.fn.displaySuburbSuggestions(n);
              }),
              (t.fn.initScript = function () {
                var e = "googleapi";
                if (0 === $("#" + e).length) {
                  var n = document.createElement("script");
                  (n.type = "text/javascript"),
                    (n.src = "https://maps.googleapis.com/maps/api/js?callback=qg_location_init&key=AIzaSyDvR5MCDqi0HtcjkehKqbKhyoCxt4Khqac"),
                    (n.id = e),
                    document.querySelector("body").appendChild(n),
                    (window.qg_location_init = function () {}),
                    (n.onload = function () {
                      t.fn.init();
                    });
                } else t.fn.init();
              }),
              (t.fn.init = function () {
                t.fn.setUpListeners();
                var e = t.fn.getStoredLocation();
                if (e) {
                  var n = "";
                  void 0 !== e.latitude && (n = "unknown" !== e.locality ? t.vars.event_locality_set : t.vars.event_coordinates_set), $("body").trigger("custom", n);
                }
              }),
              (t.fn.setUpListeners = function () {
                var e, n, a, i;
                $(".qg-location-setter-form input[type=text]").on(
                  "keyup",
                  ((e = t.fn.initManualSearch),
                  (n = 200),
                  function () {
                    var t = this,
                      o = arguments,
                      r = a && !i;
                    clearTimeout(i),
                      (i = setTimeout(function () {
                        (i = null), a || e.apply(t, o);
                      }, n)),
                      r && e.apply(t, o);
                  })
                );
              }),
              (t.fn.getStoredLocation = function () {
                var e = (function (t) {
                  var e = t + "=",
                    n = decodeURIComponent(document.cookie)
                      .split(";")
                      .filter(function (t, n) {
                        if (0 === t.trim().indexOf(e)) return !0;
                      });
                  if (n.length > 0) {
                    var a = n[0].trim();
                    return a.substring(e.length, a.length);
                  }
                  return "";
                })(t.vars.cookie_name);
                return "" !== e ? JSON.parse(e) : null;
              }),
              (t.fn.processPositionData = function (n) {
                var a = n.coords;
                t.fn.setPositionData(a), e();
              }),
              (t.fn.failure = function (e) {
                var n = e.message;
                t.vars.error_message = n;
              }),
              (t.fn.setPositionData = function (e) {
                var n = { latitude: e.latitude, longitude: e.longitude, locality: "unknown" };
                t.fn.saveLocationCookie(n), $("body").trigger("custom", t.vars.event_coordinates_set);
              }),
              (t.fn.saveLocationCookie = function (e) {
                !(function (t, e, n) {
                  var a = t + "=" + encodeURIComponent(e) + ";",
                    i = new Date();
                  i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3);
                  var o = "expires=" + i.toUTCString();
                  document.cookie = a + o + "; path=/;";
                })(t.vars.cookie_name, JSON.stringify(e), 7);
              }),
              (t.fn.saveLocality = function (e, n) {
                var a = t.fn.getStoredLocation();
                null === a && (a = { locality: "unknown" }), n && (a.address = n), (a.locality = e), t.fn.saveLocationCookie(a), $("body").trigger("custom", t.vars.event_locality_set);
              }),
              (t.fn.saveCoordinates = function (e) {
                var n = t.fn.getStoredLocation();
                null === n && (n = {}), (n.latitude = e.lat()), (n.longitude = e.lng()), t.fn.saveLocationCookie(n), $("body").trigger("custom", t.vars.event_location_found);
              }),
              (t.fn.displaySuburbSuggestions = function (t) {
                var e = $(".qg-location-setter.show .qg-location-setter-form"),
                  n = "";
                if (e) {
                  var a = e.find(".qg-location-setter-autocomplete");
                  t.length > 0 &&
                    ((n = "<ul>"),
                    t.forEach(function (t) {
                      var e = t.suburb,
                        a = t.name_formatted;
                      n += '<li><button class="qg-location-manual" tabindex="-1" data-location="' + e + '">' + a + "</button></li>";
                    }),
                    (n += "</ul>"),
                    a.removeClass("hide")),
                    a.html(n);
                }
              }),
              (t.fn.setLocationName = function () {
                var e = t.fn.getStoredLocation().locality;
                $(".header-location .dropdown-toggle").attr("aria-label", "Your location is " + e),
                  $(".header-location .location-name").text(e),
                  setTimeout(function () {
                    $(".qg-location-default").addClass("hide"), $(".qg-location-set").removeClass("hide");
                  }, 300);
              }),
              (t.fn.initServiceCentre = function () {
                var e = $(".qg-service-centre__wrapper");
                if (e.length > 0) {
                  var n = t.fn.getStoredLocation(),
                    a = e.attr("data-types").split("; "),
                    i = a.indexOf("None");
                  -1 !== i && a.splice(i, 1);
                  var o = n.latitude + "," + n.longitude,
                    r = e.attr("data-centres"),
                    s = a.join("+");
                  $.ajax({ cache: !0, dataType: "json", url: r, data: "&origin=" + o + "&meta_datasource_orsand=" + s, success: t.fn.findServiceCentre });
                }
              }),
              (t.fn.findServiceCentre = function (t) {
                var e = t.response.resultPacket.results,
                  n = null,
                  a = $(".qg-service-centre__results"),
                  i = "";
                if ((e.length > 0 && (n = e[0]), n && n.listMetadata)) {
                  var o = n.listMetadata.t,
                    r = n.listMetadata.id,
                    s = n.kmFromOrigin,
                    c = n.listMetadata.address1,
                    l = n.listMetadata.address2,
                    d = n.listMetadata.datasource;
                  void 0 !== d && (d = d[0].toLowerCase());
                  var u = a.attr("data-" + d);
                  if ("hsc" === d) u += "id=" + r + "&title=" + o;
                  else u += o;
                  (i += '<a href="' + u + '" class="qg-service-centre__link" data-analytics-link-group="qg-nearest-service-centre-details">' + o + "</a>"),
                    (i += '<ul class="qg-service-centre-list">'),
                    (i += '<li class="qg-service-centre-list-item service-info">'),
                    (i += '<a href="' + u + '" data-analytics-link-group="qg-nearest-service-centre-services">Services available</a>'),
                    (i += "</li>"),
                    null !== s && (i += '<li class="qg-service-centre-list-item centre-distance">' + s + " km away</li>"),
                    (i += '<li class="qg-service-centre-list-item">'),
                    void 0 !== c && (i += '<span class="qg-service-centre__address">' + c + "</span>"),
                    void 0 !== l && (i += '<span class="qg-service-centre__address">' + l + "</span>"),
                    (i += "</li>"),
                    (i += "</ul>");
                } else i += "<p>Browse all service centre locations to find the nearest one to you.</p>";
                a.html(i);
              }),
              (t.fn.resetLocationContainers = function () {
                var t = "unknown",
                  n = $(".qg-location-setter-form input[type=text]");
                e(),
                  $(".header-location .dropdown-toggle").attr("arisa-label", "Your location is " + t),
                  $(".header-location .location-name").text(t),
                  $(".qg-location-setter-error").addClass("hide"),
                  $(".qg-location-setter-form input[type=text]").removeClass("error"),
                  n.attr("data-choice", ""),
                  n.attr("data-choice-full", ""),
                  n.val(""),
                  setTimeout(function () {
                    $(".qg-location-default").removeClass("hide"), $(".qg-location-set").addClass("hide");
                  }, 300);
              }),
              (t.fn.closeServiceCentre = function () {
                $("#qg-service-centre-location-setter").collapse("hide");
              }),
              $(".qg-location-setter .set-location").on("focus", function () {
                $(".qg-location-setter-autocomplete").addClass("hide");
              }),
              $(document).ready(function () {
                $(".header-location").length > 0 && t.fn.initScript();
              }),
              $("body").on("custom", function (e, n) {
                switch (n) {
                  case t.vars.event_coordinates_set:
                    t.fn.getLocality();
                    break;
                  case t.vars.event_locality_set:
                    t.fn.getCoordinates();
                    break;
                  case t.vars.event_location_found:
                    t.fn.setLocationName(), t.fn.initServiceCentre();
                    break;
                  case t.vars.event_location_cleared:
                    t.fn.resetLocationContainers();
                }
              }),
              $("body").on("click", ".qg-location-setter .detect-location", t.fn.getDeviceLocation),
              $("body").on("click", ".qg-location-setter .clear-location", t.fn.deletePositionData),
              $("body").on("click", ".qg-location-setter .qg-location-manual", t.fn.getManualSuburbName),
              $("body").on("click", ".qg-location-setter .set-location", t.fn.setManualSuburb),
              $("body").on("click", ".qg-location-setter .qg-location-setter-close", t.fn.closeLocationPopup),
              $("body").on("submit", ".qg-location-setter .qg-location-setter-form", t.fn.locationSubmitHandler),
              $("body").on("click", t.fn.closePopupIfOutside),
              $("body").on("click", t.fn.closeSuburbsIfOutside),
              $("body").on("click", ".qg-location-setter-close", t.fn.closeServiceCentre),
              $("body").on("keydown", ".qg-location-setter-autocomplete button", t.fn.keyboardNavigation);
          })(jQuery);
        },
        929: (t) => {
          "use strict";
          var e = (function () {
            function t(t) {
              return t.toLowerCase().replace(/ /g, "");
            }
            return {
              highlightNavItem: function () {
                var e = (function ($) {
                  var e = "";
                  if ($("#guide-title").length > 0) e = $("#guide-title").text();
                  else if ($('meta[name="DCTERMS.alternative"]').length > 0 && "" !== t($('meta[name="DCTERMS.alternative"]').eq(0).attr("content"))) e = $('meta[name="DCTERMS.alternative"]').eq(0).attr("content");
                  else {
                    var n = $("h1", "#qg-primary-content").eq(0).clone();
                    n.find(".page-number").remove(), (e = n.text());
                  }
                  return t(e);
                })(jQuery);
                (function($) {
                  if ($(".guide-sub-nav").length > 0) {
                    var n = $.trim($("h2", "#qg-primary-content").eq(0).text());
                    $(".guide-sub-nav >li").each(function () {
                      t($(this).clone().find(".page-number").remove().end().text().trim()) === t(n) && $(this).find("a").addClass("active").removeAttr("href");
                    });
                  } else
                    $(".qg-section-nav ul>li, #qg-section-nav ul>li").each(function () {
                      $.trim(t($(this).text())) === $.trim(e) && $(this).find("a").addClass("active").removeAttr("href");
                    });
                })(jQuery);
              },
            };
          })();
          t.exports = e;
        },
        602: (t, e, n) => {
          var a = n(698);
          !(function (t) {
            "use strict";
            var e = "Please check your answers",
              n = '<div class="alert alert-warning mt-4" id="qg-forms__validation-errors" role="alert"><div class="inner"><h2><span class="fa fa-exclamation-triangle"></span>'.concat(e, "</h2><ol></ol></div></div>"),
              i = "input, select, textarea",
              o = function () {
                return !(this.disabled || this.validity.valid);
              },
              r = "formValidation",
              s = function (t, e) {
                var n = this.data(r) || this.data(r, {}).data(r);
                return void 0 !== t ? (void 0 !== e ? ((n[t] = e), e) : void 0 !== n[t] ? n[t] : null) : n;
              },
              c = function (e, n) {
                return this.map(function (i, o) {
                  var r = t(o),
                    s = null,
                    c = null;
                  return (
                    "object" === a(n) && "group" === n.level
                      ? (c = r.formValidation("group").find(e)[0])
                      : r.is(":radio, :checkbox")
                      ? (c = r.closest("fieldset").find(e)[0])
                      : (c = (s = r.closest("form").find('label[for="' + o.id + '"]')).children(e)[0]) || (".hint" === e && (s.append('<small class="hint"></small>'), (c = s.children(e)[0]))),
                    c
                  );
                });
              },
              l = function () {
                var n,
                  a,
                  r = t(this),
                  s = r.formValidation("alert");
                this.validity.valid
                  ? (r.formValidation("question").find(".alert").filter(s).length > 0 ? s.remove() : (a = r.formValidation("group").find(i).filter(o)).length > 0 ? s.text(a.formValidation("getValidationMessage")) : s.remove(),
                    r
                      .parentsUntil("form", ".invalid")
                      .filter(function () {
                        return 0 === t(this).find(i).filter(o).length;
                      })
                      .removeClass("invalid")
                      .find(t(".alert:contains(".concat(e, ")")))
                      .remove())
                  : (0 === s.length && (s = t('<em class="alert"/>')),
                    s.text(r.formValidation("getValidationMessage")),
                    r.formValidation("group").hasClass("atomic") && (n = { level: "group" }),
                    r.formValidation("label", n).parent().find('.label, abbr[title="(required)"]').eq(-1).after(s));
              },
              d = function () {
                var e = t(this).closest("form"),
                  a = e.find(i).filter(function t() {
                    if (this.disabled) return !1;
                    if ("radio" === this.type) {
                      if (t.cache) {
                        if (!0 === t.cache[this.name]) return !1;
                      } else t.cache = {};
                      t.cache[this.name] = !0;
                    }
                    return this.validity && !this.validity.valid;
                  }),
                  o = (s.call(e, "summaryElement") || s.call(e, "summaryElement", t(n))).find("ol"),
                  r = !0;
                return (
                  a.length > 0 &&
                    (o.find("li").remove(),
                    a.each(function () {
                      var e,
                        n,
                        a = t(this),
                        i = a.formValidation("group"),
                        c = a.formValidation("label", { level: i.length > 0 ? "group" : null });
                      (e = c.length > 0 ? c[0].id || c.generateId("label-" + this.id)[0].id : this.name),
                        (n = s.call(a, "summaryElement") || s.call(a, "summaryElement", t('<li><a href="#' + e + '"></a></li>'))),
                        0 === i.length || i[0] !== r
                          ? ((r = i[0]),
                            n
                              .find("a")
                              .text(c.text().replace(/\?$/, "") + ": " + a.formValidation("getValidationMessage"))
                              .end()
                              .appendTo(o))
                          : n.remove();
                    })),
                  a.length
                );
              },
              u = function (n) {
                var a = d.call(this),
                  r = t(this);
                if (
                  (r
                    .find(".invalid")
                    .filter(function () {
                      return 0 === t(this).find(i).filter(o).length;
                    })
                    .removeClass("invalid")
                    .find(t(".alert:contains(".concat(e, ")")))
                    .remove(),
                  a > 0)
                )
                  return (
                    n.stopImmediatePropagation(),
                    n.preventDefault(),
                    (function (n) {
                      var a = s.call(n, "summaryElement");
                      n.prev(".alert:contains(".concat(e, ")")).not(a).remove(), n.before(a.fadeIn()), window.innerWidth < 992 ? t(window).scrollTop(a.offset().top - t(".qg-site-header").height()) : t(window).scrollTop(a.offset().top);
                    })(r),
                    r
                      .find(i)
                      .filter(o)
                      .each(function () {
                        l.call(this);
                      })
                      .parentsUntil("form", ".questions > li")
                      .not(".section, .compact")
                      .addClass("invalid"),
                    r.trigger("x-invalid"),
                    !1
                  );
              },
              f = function (e) {
                var n,
                  a = e.timeStamp || t.now(),
                  i = t(this),
                  o = s.call(i, "summaryElement");
                if ((o && o.remove(), (n = s.call(i, "lastSubmitTimeStamp")) && a - n < 1e4)) return e.stopImmediatePropagation(), e.preventDefault(), !1;
                s.call(i, "lastSubmitTimeStamp", a);
              },
              h = {
                alert: function () {
                  return this.map(function (e, n) {
                    var a,
                      i = t(n);
                    return !0 === i.is(":radio, :checkbox")
                      ? i.closest("fieldset").find("legend > .alert")[0]
                      : (a = i.formValidation("group").filter(".atomic")).length > 0
                      ? a.find("legend > .alert")[0]
                      : t('label[for="' + n.id + '"] > .alert')[0];
                  });
                },
                label: function (t) {
                  return c.call(this, ".label", t);
                },
                hint: function (t) {
                  return c.call(this, ".hint", t);
                },
                question: function (e) {
                  return "object" === a(e) && "group" === e.level
                    ? this.formValidation("group")
                    : this.map(function (e, n) {
                        return t(n).parentsUntil("form", ".questions > li")[0];
                      });
                },
                group: function () {
                  return this.map(function (e, n) {
                    return t(n)
                      .parentsUntil("form", ".group")
                      .filter(function () {
                        return t(this).children("fieldset").length > 0;
                      })[0];
                  });
                },
                validate: function () {
                  return this.each(function () {
                    t(this).closest("form").attr("novalidate", !0).off("submit", f).off("submit", u).on("submit", u).on("submit", f).find(i).off("change", l).on("change", l);
                  });
                },
                validateNow: function (t) {
                  return u.call(this, t);
                },
                getValidationMessage: function () {
                  var t = this[0].validity;
                  return void 0 === t || !0 === t.valid
                    ? ""
                    : t.valueMissing
                    ? "Must be completed"
                    : t.customError
                    ? this[0].validationMessage
                    : t.typeMismatch
                    ? "Must be an email address"
                    : t.patternMismatch
                    ? "Must use the format shown"
                    : "Must be a valid answer";
                },
              };
            (t.fn.formValidation = function (e) {
              return h[e] ? h[e].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" !== a(e) && e ? void t.error("Method " + e + " does not exist on jQuery.formValidation") : h.init.apply(this, arguments);
            }),
              (t.fn.forcesForms = t.fn.formValidation);
          })(jQuery),
            (function (t) {
              "use strict";
              t.fn.generateId = function (e) {
                var n = 1;
                return (
                  (e = e ? t.trim(e.toLowerCase().replace(/[^a-z0-9_]+/g, " ")).replace(/\s+/g, "-") : "id"),
                  this.each(function () {
                    var t;
                    if (!this.getAttribute("id")) {
                      for (t = e; document.getElementById(t); ) (t = e + String(n)), n++;
                      this.setAttribute("id", t);
                    }
                  })
                );
              };
            })(jQuery),
            "undefined" !== jQuery &&
              (function (t) {
                "use strict";
                var e,
                  n = /^[A-Za-z0-9!#$%&'*+\-\/=\?\^_`\{\|\}~\.]+@[A-Za-z0-9\-]+(\.[A-Za-z0-9\-]+)*$/,
                  i = "input, select, textarea",
                  o = t("<input>").get(0),
                  r = "object" !== a(o.validity),
                  s = !r && !0 === t('<input type="radio" required checked>').get(0).validity.valueMissing,
                  c = function () {
                    return !(this.disabled || this.validity.valid);
                  },
                  l = function (e) {
                    return t(e.form.elements[e.name]).filter('[name="' + e.name + '"]');
                  },
                  d = function (t, e, n, a, i) {
                    return "string" == typeof a && (n = !!a), { customError: n, typeMismatch: !!t, patternMismatch: !!i, valueMissing: !!e, valid: !(e || n || t || i) };
                  },
                  u = function (e) {
                    var a,
                      i,
                      o,
                      r = !!t(this).attr("required"),
                      s = "radio" === this.type && l(this),
                      c = "email" === this.getAttribute("type") && !!this.value && !n.test(this.value);
                    return (
                      s && !r && (r = s.filter("[required]").length > 0),
                      r && (a = /^select$/i.test(this.nodeName) ? 0 === this.selectedIndex && "" === this.options[0].value : s ? 0 === s.filter(":checked").length : "checkbox" === this.type ? !this.checked : !this.value),
                      this.getAttribute("pattern") && (i = this.value.length > 0 && !new RegExp("^(?:" + this.getAttribute("pattern") + ")$").test(this.value)),
                      (o = d(c, a, this.validity.customError || !1, e, i)),
                      s
                        ? l(this).each(function () {
                            this.validity = o;
                          })
                        : (this.validity = o),
                      this.validity.valid
                        ? (this.validationMessage = "")
                        : this.validity.customError
                        ? "string" == typeof e && (this.validationMessage = e)
                        : this.validity.valueMissing
                        ? (this.validationMessage = "Please answer this question")
                        : this.validity.typeMismatch
                        ? (this.validationMessage = "Please type an email address")
                        : this.validity.patternMismatch
                        ? (this.validationMessage = "Please use the format shown")
                        : (this.validationMessage = "Please answer the question correctly"),
                      this.disabled || this.validity.valid
                    );
                  },
                  f = function (t) {
                    var e = t.target;
                    u.call(e),
                      "radio" === e.type &&
                        l(e).each(function () {
                          (this.validity = e.validity), (this.validationMessage = e.validationMessage);
                        });
                  },
                  h = function (n) {
                    var a = t(this),
                      o = !!a.attr("novalidate"),
                      l = !1;
                    if (
                      (r &&
                        a.find(i).each(function () {
                          (l = !u.call(this)), o || (l && t(this).triggerHandler("invalid"));
                        }),
                      s && e(this),
                      !o && a.find(i).filter(c).length > 0)
                    )
                      return n.stopImmediatePropagation(), n.preventDefault(), !1;
                  },
                  g = function () {
                    var n = t(i);
                    r &&
                      (n
                        .filter(function () {
                          return "object" !== a(this.validity);
                        })
                        .each(function () {
                          (this.validity = d(!1, !1, !1, "", !1)), (this.validationMessage = "");
                        }),
                      n.off("change.constraintValidationAPI").on("change.constraintValidationAPI", f)),
                      "string" != typeof o.validationMessage &&
                        n
                          .filter(function () {
                            return "string" != typeof this.validationMessage;
                          })
                          .each(function () {
                            this.validationMessage = "";
                          }),
                      "function" != typeof o.checkValidity &&
                        n
                          .filter(function () {
                            return "function" != typeof this.checkValidity;
                          })
                          .each(function () {
                            var e = this;
                            this.checkValidity = function () {
                              var n = u.call(e);
                              return n || this.form.getAttribute("novalidate") || t(e).triggerHandler("invalid"), n;
                            };
                          }),
                      "function" != typeof o.setCustomValidity &&
                        n
                          .filter(function () {
                            return "function" != typeof this.setCustomValidity;
                          })
                          .each(function () {
                            var t = this;
                            this.setCustomValidity = function (e) {
                              u.call(t, e);
                            };
                          }),
                      s &&
                        ((e = function (e) {
                          var n,
                            a = {};
                          t("input", e)
                            .filter(":radio")
                            .filter('[required],[aria-required="true"]')
                            .each(function () {
                              void 0 === a[this.name] && ((a[this.name] = !0), (n = l(this)), 0 === n.filter(":checked").length ? n.attr("required", "required") : n.attr("aria-required", !0).removeAttr("required"));
                            });
                        }),
                        t("form").each(e),
                        r ||
                          n
                            .filter(":radio")
                            .off("change.constraintValidationAPI")
                            .on("change.constraintValidationAPI", function () {
                              e(this.form);
                            })),
                      t("form").off("submit.constraintValidationAPI").on("submit.constraintValidationAPI", h);
                  };
                g(), t(g), (window.initConstraintValidationAPI = g);
              })(jQuery),
            (function (t) {
              t.fn.simplyCountable = function (e) {
                e = t.extend(
                  {
                    counter: "#counter",
                    countType: "characters",
                    maxCount: 140,
                    strictMax: !1,
                    countDirection: "down",
                    safeClass: "safe",
                    overClass: "over",
                    thousandSeparator: ",",
                    onOverCount: function () {},
                    onSafeCount: function () {},
                    onMaxCount: function () {},
                  },
                  e
                );
                var n = [33, 34, 35, 36, 37, 38, 39, 40];
                return t(this).each(function () {
                  var a = t(this),
                    i = t(e.counter);
                  if (!i.length) return !1;
                  var o = function () {
                    var n,
                      o,
                      r,
                      s = function () {
                        return "up" === e.countDirection ? o : n;
                      },
                      c = function (t) {
                        a.val(t).trigger("change");
                      };
                    if (("words" === e.countType ? ((n = e.maxCount - t.trim(a.val()).split(/\s+/).length), "" === a.val() && (n += 1)) : (n = e.maxCount - a.val().length), (o = (r = n) - 2 * r + e.maxCount), e.strictMax && n <= 0)) {
                      var l = a.val();
                      if ((n < 0 && e.onMaxCount(s(), a, i), "words" === e.countType)) {
                        var d = l.match(new RegExp("\\s?(\\S+\\s+){" + e.maxCount + "}"));
                        d && c(d[0]);
                      } else c(l.substring(0, e.maxCount));
                      (n = 0), (o = e.maxCount);
                    }
                    i.text(
                      (function (t) {
                        var n = "";
                        if (e.thousandSeparator) {
                          (t = t.toString()).match(/^-/) && ((t = t.substr(1)), (n = "-"));
                          for (var a = t.length - 3; a > 0; a -= 3) t = t.substr(0, a) + e.thousandSeparator + t.substr(a);
                        }
                        return n + t;
                      })(s())
                    ),
                      i.hasClass(e.safeClass) || i.hasClass(e.overClass)
                        ? n < 0 && i.hasClass(e.safeClass)
                          ? (i.removeClass(e.safeClass).addClass(e.overClass), e.onOverCount(s(), a, i))
                          : n >= 0 && i.hasClass(e.overClass) && (i.removeClass(e.overClass).addClass(e.safeClass), e.onSafeCount(s(), a, i))
                        : n < 0
                        ? i.addClass(e.overClass)
                        : i.addClass(e.safeClass);
                  };
                  o(),
                    a.on("keyup blur paste", function (e) {
                      switch (e.type) {
                        case "keyup":
                          t.inArray(e.which, n) < 0 && o();
                          break;
                        case "paste":
                          setTimeout(o, "paste" === e.type ? 5 : 0);
                          break;
                        default:
                          o();
                      }
                    });
                });
              };
            })(jQuery),
            "undefined" !== jQuery &&
              (function (t) {
                "use strict";
                var e,
                  n,
                  i = "button, input, select, textarea",
                  o = ((e = t("<div hidden></div>")), (n = e.appendTo("body").is(":hidden")), e.remove(), !n),
                  r = function (e, n) {
                    return t(e.elements[n]).filter('[name="' + n + '"]');
                  },
                  s = function () {
                    return 0 === t(this).closest("[hidden]").length;
                  },
                  c = function () {
                    return t(this).closest("[hidden]").length > 0;
                  },
                  l = function (t) {
                    return t.value;
                  },
                  d = function (e, n) {
                    var i;
                    for ("object" !== a(e) && (e = [e]), i = 0; i < n.length; i++) if (-1 !== t.inArray(n[i], e)) return !0;
                    return !1;
                  },
                  u = function () {
                    var e = t(this.form).data("relevance").dependencyMap[this.name],
                      n = t.map(r(this.form, this.name).filter("select,:checked").filter(":visible"), l);
                    t.each(e, function (t, e) {
                      e.items.relevance("relevant", d(e.values, n) !== e.negate);
                    });
                  },
                  f = function (e) {
                    var n, i, o;
                    (n = this.closest("form")).length &&
                      ((i = n.data("relevance")),
                      "object" === a(i) &&
                        ((i = i.dependencyMap),
                        "object" === a(i) &&
                          ((o = this.add(this.find("select,input")).filter("select,:radio,:checkbox")),
                          (o = t.unique(
                            t.map(o, function (t) {
                              return t.name;
                            })
                          )),
                          t.each(o, function (o, s) {
                            var c,
                              u = i[s];
                            "object" === a(u) &&
                              t.each(u, function (a, i) {
                                !1 === e ? i.items.relevance("relevant", !1) : ((c = t.map(r(n[0], s).filter("select,:checked").filter(":visible"), l)), i.items.relevance("relevant", d(i.values, c) !== i.negate));
                              });
                          }))));
                  },
                  h = {
                    relevant: function (t) {
                      var e;
                      return (e = t ? this.filter(c).trigger("relevant") : this.filter(s).trigger("irrelevant")).length && f.call(e, t), this;
                    },
                    show: function () {
                      return (
                        this.add(this.find(i))
                          .not(this.find("[hidden]").find(i))
                          .each(function () {
                            this.removeAttribute("disabled");
                          }),
                        o && this.stop(!0, !0).slideDown(),
                        this.removeAttr("hidden").removeAttr("aria-hidden")
                      );
                    },
                    hide: function () {
                      return (
                        this.attr({ hidden: "hidden", "aria-hidden": "true" }),
                        o
                          ? this.stop(!0, !0).hide(0, function () {
                              var e = t(this);
                              e.filter(i)
                                .add(e.find(i))
                                .each(function () {
                                  this.setAttribute("disabled", "disabled");
                                });
                            })
                          : this.filter(i)
                              .add(this.find(i))
                              .each(function () {
                                this.setAttribute("disabled", "disabled");
                              }),
                        this
                      );
                    },
                    relevantWhen: function (e) {
                      var n, i, o, s;
                      return (
                        (s = e.values || [e.value]),
                        e.name ? (o = e.name) : e.id ? (o = document.getElementById(e.id).name) : e.container && (o = t(e.container).find("select,:radio,:checkbox").attr("name")),
                        (e.negate = !0 === e.negate),
                        (i = (n = this.closest("form")).data("relevance")),
                        "object" !== a(i) && ((i = {}), n.data("relevance", i)),
                        "object" !== a(i.dependencyMap) && (i.dependencyMap = {}),
                        "object" !== a(i.dependencyMap[o]) && ((i.dependencyMap[o] = []), r(n[0], o).filter(":radio,:checkbox").on("click", u).end().filter("select").on("change", u)),
                        i.dependencyMap[o].push({ items: this, values: s, negate: e.negate }),
                        this.relevance("relevant", d(s, t.map(r(n[0], o).filter("select,:checked").filter(":visible"), l)) !== e.negate),
                        this
                      );
                    },
                    instructions: function (e) {
                      return (
                        (e = t.extend({ instructionSelector: ".relevance", questionSelector: ".questions > li" }, e)),
                        this.find(e.instructionSelector).each(function () {
                          var n,
                            a,
                            i,
                            o = t(this),
                            r = o.text(),
                            s = o.closest(e.questionSelector),
                            c = s.prevAll(e.questionSelector),
                            u = !1,
                            f = !1;
                          if (/If different to/.test(r)) (u = !0), (r = (c = c.eq(0)).find(":checkbox").val()), (f = !0);
                          else
                            for (r = r.replace(/^.*chose\s+\S([^'"â€™]+)\S\s+above.*$/, "$1"), n = 0; n < c.length; )
                              (a = t.map(c.eq(n).find("option,:radio,:checkbox"), l)), d(r, a) ? ((i = c.eq(n).find(e.questionSelector)).length ? ((c = t(i.get().reverse())), (n = 0)) : ((u = !0), (c = c.eq(n)), (n = 1))) : n++;
                          u && ((c = c.add(c.find("select,input")).filter("select,:radio,:checkbox")), s.relevance("relevantWhen", { name: c.attr("name"), value: r, negate: f }));
                        }),
                        this
                      );
                    },
                  };
                t(document).on("relevant irrelevant", function (e) {
                  var n = t(e.target);
                  "relevant" === e.type ? n.relevance("show") : n.relevance("hide");
                }),
                  (t.fn.relevance = function (e) {
                    return h[e] ? h[e].apply(this, Array.prototype.slice.call(arguments, 1)) : "object" !== a(e) && e ? void t.error("Method " + e + " does not exist on jQuery.relevance") : this;
                  });
              })(jQuery),
            (function (t) {
              "use strict";
              var e;
              "object" === a(t('<input type="file">')[0].files)
                ? ((e = function (t) {
                    if ((t.nextAll(".fsize").remove(), t[0].files.length > 0)) {
                      var e = t[0].files[0].size / 1024;
                      e >= 1024 ? ((e /= 1024), t.after('<span class="fsize">File size: ' + Math.round(10 * e) / 10 + "MB</span>")) : t.after('<span class="fsize">File size: ' + Math.round(10 * e) / 10 + "KB</span>");
                    }
                  }),
                  t(".max-fsize").each(function () {
                    var n,
                      a = t(this);
                    (n = 1024 * parseInt(a.text().replace(/\D+/g, ""), 10) * 1024),
                      a
                        .closest(".preamble")
                        .nextAll("form")
                        .eq(0)
                        .find(":file")
                        .on("change", function () {
                          var a = t(this);
                          e(a);
                          var i,
                            o = 0;
                          t(":file", this.form).each(function (t, e) {
                            var n = e.files.length ? e.files[0].size : 0;
                            o += n;
                          }),
                            (i = o <= n),
                            t(":file", this.form)
                              .filter(function () {
                                return !!this.value;
                              })
                              .each(function (t, e) {
                                e.setCustomValidity(i ? "" : "Attachments are too large");
                              })
                              .filter(function () {
                                return !this.value;
                              })
                              .each(function (t, e) {
                                e.setCustomValidity("");
                              });
                        });
                  }))
                : t(".max-fsize").each(function () {
                    var e = t(this);
                    e.closest(".preamble")
                      .nextAll("form")
                      .eq(0)
                      .find(".actions")
                      .before("<p>" + e.parent().html() + "</p>");
                  });
            })(jQuery),
            (function (t) {
              "use strict";
              var e = function (t) {
                  var e = t.data[0],
                    n = t.data[1],
                    a =
                      e.filter(function () {
                        return this.value.length > 1;
                      }).length > 0;
                  e.each(function () {
                    this.setCustomValidity(a ? "" : n);
                  });
                },
                n = function (t, n) {
                  if (!0 !== n) {
                    var a = t.data[0];
                    e(t), "change" === t.type && a.not(t.target).triggerHandler("change", !0);
                  }
                };
              t.fn.initXorConstraint = function (t) {
                this.closest("form").on("submit", [this, t], e), this.on("change", [this, t], n);
              };
            })(jQuery),
            (function (t) {
              "use strict";
              t('abbr[title*="required"]').addClass("required"),
                t(".questions > li")
                  .not(".section")
                  .on("relevant", function (e) {
                    t(this).relevance("show"), e.stopImmediatePropagation();
                  })
                  .on("irrelevant", function (e) {
                    t(this).relevance("hide"), e.stopImmediatePropagation();
                  }),
                t(".matrix").delegate("td", "click", function (e) {
                  t(e.target).find("input").trigger("click").trigger("change");
                });
            })(jQuery),
            (function (t) {
              "use strict";
              var e = function () {
                window.initConstraintValidationAPI(), t("form").formValidation("validate");
              };
              e(), t(e), t(".relevance", "form").length > 0 && t("#qg-primary-content form").relevance("instructions");
            })(jQuery),
            (function (t) {
              "use strict";
              t.fn.toggleRequired = function (e) {
                return this.each(function () {
                  var n = t(this.form.elements[this.name]),
                    a = t(this).closest(".questions > li");
                  e
                    ? (0 === a.find('abbr[title="(required)"]').length && a.find(".label").after(t(document.createElement("abbr")).attr("title", "(required)").text("*").addClass("required")), n.attr("required", "required"))
                    : (n.removeAttr("required"), a.find('abbr[title="(required)"]').remove());
                });
              };
            })(jQuery);
          !(function () {
            "use strict";
            var t = {},
              e = {
                "2010-01-01": "New Yearâ€™s Day",
                "2010-01-26": "Australia Day",
                "2010-04-02": "Good Friday",
                "2010-04-03": "Easter Saturday",
                "2010-04-05": "Easter Monday",
                "2010-04-26": "Anzac Day",
                "2010-05-03": "Labour Day",
                "2010-06-14": "Queenâ€™s Birthday",
                "2010-12-25": "Christmas Day",
                "2010-12-27": "Boxing Day",
                "2010-12-28": "Christmas Day holiday",
                "2011-01-01": "New Yearâ€™s Day",
                "2011-01-03": "New Yearâ€™s Day holiday",
                "2011-02-26": "Australia Day",
                "2011-04-22": "Good Friday",
                "2011-04-23": "Easter Saturday",
                "2011-04-25": "Anzac Day",
                "2011-04-26": "Easter Monday",
                "2011-05-02": "Labour Day",
                "2011-06-13": "Queenâ€™s Birthday",
                "2011-12-25": "Christmas Day",
                "2011-12-26": "Boxing Day",
                "2011-12-27": "Christmas Day holiday",
                "2012-01-01": "New Yearâ€™s Day",
                "2012-01-02": "New Yearâ€™s Day holiday",
                "2012-02-26": "Australia Day",
                "2012-04-06": "Good Friday",
                "2012-04-07": "Easter Saturday",
                "2012-04-09": "Easter Monday",
                "2012-04-25": "Anzac Day",
                "2012-05-07": "Labour Day",
                "2012-06-11": "Queenâ€™s Diamond Jubilee",
                "2012-10-01": "Queenâ€™s Birthday",
                "2012-12-25": "Christmas Day",
                "2012-12-26": "Boxing Day",
                "2013-01-01": "New Yearâ€™s Day",
                "2013-01-28": "Australia Day holiday",
                "2013-03-29": "Good Friday",
                "2013-03-30": "Easter Saturday",
                "2013-04-01": "Easter Monday",
                "2013-04-25": "Anzac Day",
                "2013-06-10": "Queenâ€™s Birthday",
                "2013-10-07": "Labour Day",
                "2013-12-25": "Christmas Day",
                "2013-12-26": "Boxing Day",
                "2014-01-01": "New Yearâ€™s Day",
                "2014-01-27": "Australia Day holiday",
                "2014-04-18": "Good Friday",
                "2014-04-19": "Easter Saturday",
                "2014-04-21": "Easter Monday",
                "2014-04-25": "Anzac Day",
                "2014-06-09": "Queenâ€™s Birthday",
                "2014-10-06": "Labour Day",
                "2014-12-25": "Christmas Day",
                "2014-12-26": "Boxing Day",
                "2015-01-01": "New Yearâ€™s Day",
                "2015-01-26": "Australia Day holiday",
                "2015-04-03": "Good Friday",
                "2015-04-04": "Easter Saturday",
                "2015-04-06": "Easter Monday",
                "2015-04-25": "Anzac Day",
                "2015-06-08": "Queenâ€™s Birthday",
                "2015-10-05": "Labour Day",
                "2015-12-25": "Christmas Day",
                "2015-12-26": "Boxing Day",
                "2015-12-28": "Boxing Day holiday",
                "2016-01-01": "New Yearâ€™s Day",
                "2016-01-26": "Australia Day holiday",
                "2016-03-25": "Good Friday",
                "2016-03-26": "Easter Saturday",
                "2016-03-28": "Easter Monday",
                "2016-04-25": "Anzac Day",
                "2016-06-13": "Queenâ€™s Birthday",
                "2016-10-03": "Labour Day",
                "2016-12-25": "Christmas Day",
                "2016-12-27": "Christmas Day holiday",
                "2016-12-26": "Boxing Day",
                "2017-01-01": "New Yearâ€™s Day",
                "2017-01-02": "New Yearâ€™s Day holiday",
                "2017-01-26": "Australia Day holiday",
                "2017-04-14": "Good Friday",
                "2017-04-15": "Easter Saturday",
                "2017-04-17": "Easter Monday",
                "2017-04-25": "Anzac Day",
                "2017-06-12": "Queenâ€™s Birthday",
                "2017-10-02": "Labour Day",
                "2017-12-25": "Christmas Day",
                "2017-12-26": "Boxing Day",
                "2018-01-01": "New Yearâ€™s Day",
                "2018-01-26": "Australia Day holiday",
                "2018-03-30": "Good Friday",
                "2018-03-31": "Easter Saturday",
                "2018-04-02": "Easter Monday",
                "2018-04-25": "Anzac Day",
                "2018-05-07": "Labour Day",
                "2018-10-01": "Queenâ€™s Birthday",
                "2018-12-25": "Christmas Day",
                "2018-12-26": "Boxing Day",
              };
            t.isPublicHoliday = function (t) {
              var n = t.getDate(),
                a = t.getMonth() + 1,
                i = String(t.getFullYear());
              return !!e[i + (a < 10 ? "-0" : "-") + a + (n < 10 ? "-0" : "-") + n];
            };
          })(),
            (function (t) {
              "use strict";
              t(".hint")
                .filter(function () {
                  return /Maximum:\s+\d+\s+words/.test(t(this).text());
                })
                .each(function () {
                  var e,
                    n = t(this),
                    a = parseInt(n.text().replace(/Maximum:\s+(\d+)\s+words/, "$1"), 10),
                    i = n.closest("label").nextAll("textarea");
                  (e = t("<span></span>").generateId("word-count")),
                    n.append(" (", e, " remaining)"),
                    i.simplyCountable({
                      counter: "#" + e[0].id,
                      countType: "words",
                      countDirection: "down",
                      maxCount: a,
                      onOverCount: function () {
                        i[0].setCustomValidity("Too many words");
                      },
                      onSafeCount: function () {
                        i[0].setCustomValidity("");
                      },
                    });
                });
            })(jQuery);
        },
        410: (t) => {
          "use strict";
          var e,
            n = void (e = jQuery("*[data-parent-width=true], *[data-parent-width=1]")).outerWidth(e.parent().width());
          t.exports = n;
        },
        815: () => {
          !(function (t, e) {
            qg.swe.ajaxCall = function (e, n, a, i) {
              t.ajax({
                url: e,
                dataType: n,
                crossDomain: !0,
                success: a,
                error: function () {
                  console.log(i);
                },
              });
            };
          })(jQuery);
        },
        191: () => {
          (function ($) {
            var t = function () {
              $(".dataTables_wrapper a.paginate_button").addClass("qg-btn");
            };
            $(".dataTable").each(function () {
              $.fn.DataTable.isDataTable(this) || $(this).DataTable({ drawCallback: t });
            });
          })(jQuery);
        },
        127: () => {
          (function ($) {
            var t;
            (t = document.createElement("input")).setAttribute("type", "date"),
              "text" === t.type &&
                $("input[type='date']").length > 0 &&
                $.getScript("https://static.qgov.net.au/assets/v4/latest/lib/ext/nodep-date-input-polyfill/nodep-date-input-polyfill.dist.js", function () {
                  console.log("date polyfill loaded");
                });
            var e = function () {
              $("input[class*='qg-date-input']").length > 0 &&
                ($(".qg-date-input").removeClass("hasDatepicker"), $(".qg-date-input").datepicker({ dateFormat: "dd/mm/yy", changeYear: !0, changeMonth: !0 }), $(".qg-date-input").attr("placeholder", "dd/mm/yyyy"));
            };
            $("input[class*='qg-date-input']").length > 0 &&
              $.getScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js", function () {
                $("head").append($("<link rel='stylesheet' href='https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.css' type='text/css' crossorigin='anonymous' media='screen' />"));
              }),
              e(),
              $(window).on("load", e);
          })(jQuery);
        },
        918: (t) => {
          var e = ((window.qg = window.qg || {}), void (window.qg.swe = window.qg.swe || {}));
          t.exports = e;
        },
        290: () => {
          !(function (t, e) {
            function n() {
              var t = document.querySelectorAll(".qg-cards__equal-height");
              t.length > 0 &&
                t.forEach(function (t) {
                  var e = 0,
                    n = t.querySelectorAll(".qg-card .details");
                  n.forEach(function (t) {
                    e = Math.max(e, t.offsetHeight);
                  }),
                    n.forEach(function (t) {
                      t.style.height = "".concat(e, "px");
                    });
                });
            }
            (qg.swe.getParameterByName = function (t, e) {
              if (null == t) return !1;
              e || (e = window.location.href), (t = t.replace(/[\\[\]]/g, "\\$&"));
              var n = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
              return !(!n || !n[2]) && decodeURIComponent(n[2].replace(/\+/g, " "));
            }),
              t(".map-modal").butterfly({ contentDefaultWidth: "90%", contentDefaultHeight: "90%", reuseFragment: !0 }),
              n(),
              t(window).on("resize", function () {
                t(window).width() < 767 ? t(".cards__equal-height").find(".details").removeAttr("style") : n();
              });
            var a = window.frameElement && window.frameElement.getAttribute("Name");
            a && "ees_modePreviewFrame" === a && t(".container-fluid").addClass("qg-edit-plus-styles");
            var i = [
              { selector: ".qg-callout__box .qg-callout__icon i.fa", label: "Callout box" },
              { selector: ".alert h2 i.fa", label: "Alert" },
            ];
            setTimeout(function () {
              i.forEach(function (e) {
                var n = e.selector,
                  a = e.label;
                t(n).length &&
                  console.warn(
                    "Please change the font awesome element in ".concat(
                      a,
                      " from i to span, we'll be removing the css in this element before 22nd june 2022. Please refer to the https://github.com/qld-gov-au/qg-web-template/pull/391 for more details."
                    )
                  );
              });
            }, 5e3);
          })(jQuery);
        },
        205: () => {
          (function($) {
            var t = function (t) {
              var e = $(".qg-quick-exit");
              document.documentElement.clientWidth > 992
                ? ($(this).scrollTop() > 200 && e.css({ position: "fixed", top: "0px" }), $(this).scrollTop() < 200 && e.css({ position: "sticky", top: "0px" }))
                : e.css({ position: "fixed", top: "auto" });
            };
            $(window).on("scroll", t), window.addEventListener("resize", t, !0);
          })(jQuery);
        },
        114: (t) => {
          t.exports = function (t, e) {
            t || (t = document), e || (e = window);
            var n,
              a,
              i = [],
              o = !1,
              r = t.documentElement,
              s = function () {},
              c = "hidden",
              l = "visibilitychange";
            void 0 !== t.webkitHidden && ((c = "webkitHidden"), (l = "webkitvisibilitychange")), e.getComputedStyle || h();
            for (var d = ["", "-webkit-", "-moz-", "-ms-"], u = document.createElement("div"), f = d.length - 1; f >= 0; f--) {
              try {
                u.style.position = d[f] + "sticky";
              } catch (t) {}
              "" != u.style.position && h();
            }
            function h() {
              E = M = D = P = L = T = s;
            }
            function g(t) {
              return parseFloat(t) || 0;
            }
            function p() {
              n = { top: e.pageYOffset, left: e.pageXOffset };
            }
            function m() {
              if (e.pageXOffset != n.left) return p(), void D();
              e.pageYOffset != n.top && (p(), y());
            }
            function v(t) {
              setTimeout(function () {
                e.pageYOffset != n.top && ((n.top = e.pageYOffset), y());
              }, 0);
            }
            function y() {
              for (var t = i.length - 1; t >= 0; t--) b(i[t]);
            }
            function b(t) {
              if (t.inited) {
                var e = n.top <= t.limit.start ? 0 : n.top >= t.limit.end ? 2 : 1;
                t.mode != e &&
                  (function (t, e) {
                    var n = t.node.style;
                    switch (e) {
                      case 0:
                        (n.position = "absolute"),
                          (n.left = t.offset.left + "px"),
                          (n.right = t.offset.right + "px"),
                          (n.top = t.offset.top + "px"),
                          (n.bottom = "auto"),
                          (n.width = "auto"),
                          (n.marginLeft = 0),
                          (n.marginRight = 0),
                          (n.marginTop = 0);
                        break;
                      case 1:
                        (n.position = "fixed"), (n.left = t.box.left + "px"), (n.right = t.box.right + "px"), (n.top = t.css.top), (n.bottom = "auto"), (n.width = "auto"), (n.marginLeft = 0), (n.marginRight = 0), (n.marginTop = 0);
                        break;
                      case 2:
                        (n.position = "absolute"), (n.left = t.offset.left + "px"), (n.right = t.offset.right + "px"), (n.top = "auto"), (n.bottom = 0), (n.width = "auto"), (n.marginLeft = 0), (n.marginRight = 0);
                    }
                    t.mode = e;
                  })(t, e);
              }
            }
            function w(t) {
              isNaN(parseFloat(t.computed.top)) ||
                t.isCell ||
                ((t.inited = !0),
                t.clone ||
                  (function (t) {
                    t.clone = document.createElement("div");
                    var e = t.node.nextSibling || t.node,
                      n = t.clone.style;
                    (n.height = t.height + "px"),
                      (n.width = t.width + "px"),
                      (n.marginTop = t.computed.marginTop),
                      (n.marginBottom = t.computed.marginBottom),
                      (n.marginLeft = t.computed.marginLeft),
                      (n.marginRight = t.computed.marginRight),
                      (n.padding = n.border = n.borderSpacing = 0),
                      (n.fontSize = "1em"),
                      (n.position = "static"),
                      (n.cssFloat = t.computed.cssFloat),
                      t.node.parentNode.insertBefore(t.clone, e);
                  })(t),
                "absolute" != t.parent.computed.position && "relative" != t.parent.computed.position && (t.parent.node.style.position = "relative"),
                b(t),
                (t.parent.height = t.parent.node.offsetHeight),
                (t.docOffsetTop = x(t.clone)));
            }
            function q(t) {
              var e = !0;
              t.clone &&
                (function (t) {
                  t.clone.parentNode.removeChild(t.clone), (t.clone = void 0);
                })(t),
                (function (t, e) {
                  for (key in e) e.hasOwnProperty(key) && (t[key] = e[key]);
                })(t.node.style, t.css);
              for (var n = i.length - 1; n >= 0; n--)
                if (i[n].node !== t.node && i[n].parent.node === t.parent.node) {
                  e = !1;
                  break;
                }
              e && (t.parent.node.style.position = t.parent.css.position), (t.mode = -1);
            }
            function $() {
              for (var t = i.length - 1; t >= 0; t--) w(i[t]);
            }
            function k() {
              for (var t = i.length - 1; t >= 0; t--) q(i[t]);
            }
            function C(t) {
              var e = getComputedStyle(t),
                n = t.parentNode,
                a = getComputedStyle(n),
                i = t.style.position;
              t.style.position = "relative";
              var o = { top: e.top, marginTop: e.marginTop, marginBottom: e.marginBottom, marginLeft: e.marginLeft, marginRight: e.marginRight, cssFloat: e.cssFloat },
                s = { top: g(e.top), marginBottom: g(e.marginBottom), paddingLeft: g(e.paddingLeft), paddingRight: g(e.paddingRight), borderLeftWidth: g(e.borderLeftWidth), borderRightWidth: g(e.borderRightWidth) };
              t.style.position = i;
              var c = {
                  position: t.style.position,
                  top: t.style.top,
                  bottom: t.style.bottom,
                  left: t.style.left,
                  right: t.style.right,
                  width: t.style.width,
                  marginTop: t.style.marginTop,
                  marginLeft: t.style.marginLeft,
                  marginRight: t.style.marginRight,
                },
                l = _(t),
                d = _(n),
                u = {
                  node: n,
                  css: { position: n.style.position },
                  computed: { position: a.position },
                  numeric: { borderLeftWidth: g(a.borderLeftWidth), borderRightWidth: g(a.borderRightWidth), borderTopWidth: g(a.borderTopWidth), borderBottomWidth: g(a.borderBottomWidth) },
                };
              return {
                node: t,
                box: { left: l.win.left, right: r.clientWidth - l.win.right },
                offset: { top: l.win.top - d.win.top - u.numeric.borderTopWidth, left: l.win.left - d.win.left - u.numeric.borderLeftWidth, right: -l.win.right + d.win.right - u.numeric.borderRightWidth },
                css: c,
                isCell: "table-cell" == e.display,
                computed: o,
                numeric: s,
                width: l.win.right - l.win.left,
                height: l.win.bottom - l.win.top,
                mode: -1,
                inited: !1,
                parent: u,
                limit: { start: l.doc.top - s.top, end: d.doc.top + n.offsetHeight - u.numeric.borderBottomWidth - t.offsetHeight - s.top - s.marginBottom },
              };
            }
            function x(t) {
              for (var e = 0; t; ) (e += t.offsetTop), (t = t.offsetParent);
              return e;
            }
            function _(t) {
              var n = t.getBoundingClientRect();
              return { doc: { top: n.top + e.pageYOffset, left: n.left + e.pageXOffset }, win: n };
            }
            function S() {
              a = setInterval(function () {
                !(function () {
                  for (var t = i.length - 1; t >= 0; t--)
                    if (i[t].inited) {
                      var e = Math.abs(x(i[t].clone) - i[t].docOffsetTop),
                        n = Math.abs(i[t].parent.node.offsetHeight - i[t].parent.height);
                      if (e >= 2 || n >= 2) return !1;
                    }
                  return !0;
                })() && D();
              }, 500);
            }
            function A() {
              clearInterval(a);
            }
            function F() {
              o && (document[c] ? A() : S());
            }
            function E() {
              o || (p(), $(), e.addEventListener("scroll", m), e.addEventListener("wheel", v), e.addEventListener("resize", D), e.addEventListener("orientationchange", D), t.addEventListener(l, F), S(), (o = !0));
            }
            function D() {
              if (o) {
                k();
                for (var t = i.length - 1; t >= 0; t--) i[t] = C(i[t].node);
                $();
              }
            }
            function P() {
              e.removeEventListener("scroll", m), e.removeEventListener("wheel", v), e.removeEventListener("resize", D), e.removeEventListener("orientationchange", D), t.removeEventListener(l, F), A(), (o = !1);
            }
            function L() {
              P(), k();
            }
            function T() {
              for (L(); i.length; ) i.pop();
            }
            function M(t) {
              for (var e = i.length - 1; e >= 0; e--) if (i[e].node === t) return;
              var n = C(t);
              i.push(n), o ? w(n) : E();
            }
            return (
              p(),
              {
                stickies: i,
                add: M,
                remove: function (t) {
                  for (var e = i.length - 1; e >= 0; e--) i[e].node === t && (q(i[e]), i.splice(e, 1));
                },
                init: E,
                rebuild: D,
                pause: P,
                stop: L,
                kill: T,
              }
            );
          };
        },
        897: (t) => {
          (t.exports = function (t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var n = 0, a = new Array(e); n < e; n++) a[n] = t[n];
            return a;
          }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports);
        },
        405: (t, e, n) => {
          var a = n(897);
          (t.exports = function (t) {
            if (Array.isArray(t)) return a(t);
          }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports);
        },
        498: (t) => {
          (t.exports = function (t) {
            if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
          }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports);
        },
        281: (t) => {
          (t.exports = function () {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports);
        },
        861: (t, e, n) => {
          var a = n(405),
            i = n(498),
            o = n(116),
            r = n(281);
          (t.exports = function (t) {
            return a(t) || i(t) || o(t) || r();
          }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports);
        },
        698: (t) => {
          function e(n) {
            return (
              (t.exports = e =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t;
                    }
                  : function (t) {
                      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                    }),
              (t.exports.__esModule = !0),
              (t.exports.default = t.exports),
              e(n)
            );
          }
          (t.exports = e), (t.exports.__esModule = !0), (t.exports.default = t.exports);
        },
        116: (t, e, n) => {
          var a = n(897);
          (t.exports = function (t, e) {
            if (t) {
              if ("string" == typeof t) return a(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
            }
          }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports);
        },
      },
      e = {};
    function n(a) {
      var i = e[a];
      if (void 0 !== i) return i.exports;
      var o = (e[a] = { exports: {} });
      return t[a](o, o.exports, n), o.exports;
    }
    (n.n = (t) => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return n.d(e, { a: e }), e;
    }),
      (n.d = (t, e) => {
        for (var a in e) n.o(e, a) && !n.o(t, a) && Object.defineProperty(t, a, { enumerable: !0, get: e[a] });
      }),
      (n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e)),
      (() => {
        "use strict";
        n(918), n(290), n(815);
        function t(t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }
        function e(t) {
          return (
            (e =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                  }),
            e(t)
          );
        }
        function a(t) {
          var n = (function (t, n) {
            if ("object" != e(t) || !t) return t;
            var a = t[Symbol.toPrimitive];
            if (void 0 !== a) {
              var i = a.call(t, n || "default");
              if ("object" != e(i)) return i;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === n ? String : Number)(t);
          })(t, "string");
          return "symbol" == e(n) ? n : String(n);
        }
        function i(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(t, a(i.key), i);
          }
        }
        function o(t, e, n) {
          return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
        }
        const r = JSON.parse(
          '{"e2":{"Bu":"AIzaSyCKuaFIFo7YYZXHZ5zaiEZdJx0UBoyfuAE","rx":"AIzaSyBE95_qL90MT9loY1roLnHJ3uaBYbleYeM","WV":"AIzaSyANZv-2WcXRzkBqtgEcLTZq7zVy-9eNWgw"},"BD":{"H":"6LeNGSwUAAAAAD6o-P5UTM0FNpKjYB71Kh70F-Ud","W":"6LcoIywUAAAAAN-1rq22G-bP3yxl1bBq_5nHJ6s9"},"Pf":{"H":"6Lf3uLEUAAAAAKbnWYc0iXtctL8TeFC26l43Qyt2","W":"6LcTNMIUAAAAAHiGXUnaO1xlELzXgpWujzEJbFjS"},"RP":[{"name":"about","apiKey":"AIzaSyBi-T3vrvcYwouFPqPI5IgLoQxl2hz6Ogs"},{"name":"atsi","apiKey":"AIzaSyB2mTTDd1CcLEYrLHJJHlzX60vQ68snyko"},{"name":"community","apiKey":"AIzaSyCJwNeGu0XT1lvhg-2cm7S27BQo9k7Jd9E"},{"name":"disability","apiKey":"AIzaSyC-KQFfBhoGle7kJJhY1Pf_GvR_qC5jzN4"},{"name":"education","apiKey":"AIzaSyDeeYKKOyQCYkpVWXRLLxyNjfy2dhyWVls"},{"name":"emergency","apiKey":"AIzaSyD1xT_2Dh2EZ7Iy6SLodeH8CJzbXlp6vgE"},{"name":"environment","apiKey":"AIzaSyAZJjfwIKDPlQs-S3id-CGp8U_S4U7idFI"},{"name":"families","apiKey":"AIzaSyBucRn0YhJhQ-ELSS-MM7JvYb19-I1bqqI"},{"name":"health","apiKey":"AIzaSyD_Xzvr6nBm5PlpANw2UZ2df3-U5eeOlvY"},{"name":"housing","apiKey":"AIzaSyCgMKJlbP1SRIf3xCMFDbBImNkF_BCubvk"},{"name":"jobs","apiKey":"AIzaSyBXmI1DZvPFVQ_h-E1TNsPNdlNuqDd7MVo"},{"name":"law","apiKey":"AIzaSyBeij584IMIZqpftyhMCt_lZ_hBK_h8hMc"},{"name":"recreation","apiKey":"AIzaSyDJmfdqYI3eyV8-ivwPWVIIHxBzqo5_v2I"},{"name":"seniors","apiKey":"AIzaSyA3PDnd30Twv3Zr3JKqiAUYNO1983ZDBe0"},{"name":"transport","apiKey":"AIzaSyARzyCPigCt9cW1F6ua0_U3NVLdRbxwLyg"},{"name":"youth","apiKey":"AIzaSyCe7FYHy28So2Uio_OEQje0o0Pr23s7gt0"}]}'
        );
        var s = (function () {
            function e() {
              t(this, e), (this.firstFolderPath = location.pathname.split("/")[1]), this._staticMaps();
            }
            return (
              o(e, [
                {
                  key: "_isProd",
                  value: function () {
                    return -1 === window.location.hostname.search(/dev|test|localhost|github|\buat\b/);
                  },
                },
                {
                  key: "_checkEnvAndSetKey",
                  value: function () {
                    var t,
                      e = this;
                    return (
                      (t = -1 !== window.location.hostname.search(/\bgithub\b/) ? r.e2.rx : this._isProd() ? r.e2.WV : r.e2.Bu),
                      e.firstFolderPath &&
                        r.RP.forEach(function (n) {
                          e.firstFolderPath === n.name && (t = n.apiKey);
                        }),
                      t
                    );
                  },
                },
                {
                  key: "_staticMaps",
                  value: function () {
                    var t = this._checkEnvAndSetKey();

                    (function($) {
                      var e = $(".qg-static-map");
                      if (e.length > 0) {
                        var n = $("<div>");
                        e.each(function () {
                          var e,
                            a,
                            i,
                            o,
                            r = $(this);
                          r
                            .find("img")
                            .attr(
                              "src",
                              ((e = r.find("img")),
                              (a = e.attr("data-lat") || -27.4673),
                              (i = e.attr("data-long") || 153.0233),
                              (o = e.attr("data-zoom") || 17),
                              "https://maps.googleapis.com/maps/api/staticmap?size=373x" + (e.attr("data-height") || 189) + "&maptype=roadmap&markers=" + a + "%2C" + i + "&key=" + t + "&sensor=false&zoom=" + o)
                            ),
                            n.append(r);
                        }),
                          $("aside").prepend(n),
                          $("a.qg-static-map").wrap("<div class='qg-aside st-map-static'>"),
                          $(".st-map-static").eq(0).prepend("<h2><span class='fa fa-compass' aria-hidden='true'></span>Maps</h2>");
                      }
                    })(jQuery);
                  },
                },
                {
                  key: "_loadGoogleApi",
                  value: function (t) {
                    var e = this._checkEnvAndSetKey(),
                      n = function () {
                        var e;
                        "function" == typeof t ? t() : ((e = t), $("head").append('<script type="text/javascript" src="' + e + '"></script>'));
                      };
                    if ($("#googleapi").length <= 0) {
                      var a = document.createElement("script"),
                        i = "https://maps.googleapis.com/maps/api/js?key=".concat(e, "&region=AU&libraries=places");
                      (a.type = "text/javascript"),
                        (a.id = "googleapi"),
                        (a.src = i),
                        document.getElementsByTagName("head")[0].appendChild(a),
                        (a.onreadystatechange = function () {
                          "complete" === this.readyState && n();
                        }),
                        (a.onload = function () {
                          n();
                        });
                    } else
                      "loading" === document.readyState
                        ? (document.onreadystatechange = function () {
                            "complete" === this.readyState && n();
                          })
                        : n();
                  },
                },
              ]),
              e
            );
          })(),
          c = (n(410), n(127), n(205), n(191), n(602), n(146), n(484), n(253), n(961), n(444), n(407), n(114)()),
          l = (function () {
            function e() {
              t(this, e);

              (function($) {
                (this.$quickExit = $(".qg-quick-exit"));
              }).call(this, jQuery);
              
              this.quickExitButton = document.querySelector(".qg-quick-exit__button");
              this.escapeSite = "https://www.google.com.au/";
              this.hotkey = 27;
            }
            return (
              o(e, [
                {
                  key: "init",
                  value: function () {
                    this.$quickExit.length > 0 && void 0 !== this.quickExitButton && null != this.quickExitButton && (this.onbtnClick(), this.ieFix(), this.onKeyDown());
                  },
                },
                {
                  key: "quickExit",
                  value: function (t) {
                    if ((window.open(t, "_blank"), window.location.replace(t), window.history))
                      try {
                        window.history.replaceState({}, "", "/");
                      } catch (t) {}
                    return !1;
                  },
                },
                {
                  key: "onbtnClick",
                  value: function () {
                    var t = this;
                    this.quickExitButton.onclick = function (e) {
                      return t.quickExit(t.escapeSite);
                    };
                  },
                },
                {
                  key: "onKeyDown",
                  value: function () {
                    var t = this;
                    document.addEventListener("keydown", function (e) {
                      if (e.keyCode === t.hotkey) return t.quickExit(t.escapeSite), e && (e.preventDefault(), (e.returnValue = !1)), !1;
                    });
                  },
                },
                {
                  key: "ieFix",
                  value: function () {
                    /MSIE \d|Trident.*rv:/.test(navigator.userAgent) && c.add($(".qg-quick-exit")[0]);
                  },
                },
              ]),
              e
            );
          })(),
          d = (function () {
            function e() {
              t(this, e);

              (function($) {
                  this.$pageLinks = $("#toc.qg-print-guide ol li a");
                  this.$contentContainer = $("#qg-content");
                  this.$printContentLink = $(".print-content-link");
                  this.$printguideLink = $("#printguide");
                  this.$content = this.$contentContainer.find("#qg-primary-content");
                  this.new_content = "";
                  this.current_content = "";

                  if (this.$printguideLink.length > 0 || this.$printContentLink.length > 0) {
                      this.onClickContentBtn();
                      this.onClickGuidePageBtn();
                  }
              }).call(this, jQuery);
            }
            return (
              o(e, [
                {
                  key: "onClickContentBtn",
                  value: function () {
                    this.$printContentLink.length > 0 &&
                      $(document).on("click", ".print-content-link", function (t) {
                        t.preventDefault(), window.print();
                      });
                  },
                },
                {
                  key: "onClickGuidePageBtn",
                  value: function () {
                    var t = this,
                      e = 0;
                    (t.current_content = t.$content.html()),
                      $("body").on("click", "#printguide", function (n) {
                        n.preventDefault();
                        var a;
                        (a = t.$pageLinks
                          .map(function () {
                            return this.href;
                          })
                          .get()),
                          $.each(a, function (e, n) {
                            t.getRemotePages(n);
                          }),
                          t.$content.append(t.new_content);
                        var i = t.$content.find("img"),
                          o = i.length;
                        t.$content.find("h1").not(":first").remove(),
                          t.$content.find('.qg-print-guide p:contains("In this guide")').parent().remove(),
                          t.$content.find("ul.pagination").remove(),
                          t.$content.find(".qg-content-footer").remove(),
                          0 === o
                            ? (window.print(), t.$content.empty().append(t.current_content))
                            : i.map(function () {
                                var n = this.src;
                                (this.onload = function () {
                                  ++e >= o && (window.print(), t.$content.empty().append(t.current_content));
                                }),
                                  (this.src = n);
                              });
                      });
                  },
                },
                {
                  key: "getRemotePages",
                  value: function (t) {
                    var e = this;
                    $.ajax({
                      url: t,
                      data: {},
                      success: function (t) {
                        (e.new_content += '<div id="qg-primary-content" class="d-none d-print-block">' + $(t).find("#qg-primary-content").html() + "</div>"), (e.new_content += "<hr />");
                      },
                      dataType: "html",
                      async: !1,
                    });
                  },
                },
              ]),
              e
            );
          })(),
          u = (function () {
            function e() {
              t(this, e);

              (function($) {
                this.$accordion = $(".qg-accordion");
                this.$accordion_v2 = $(".qg-accordion-v2");
                this.$accHeading = $(".acc-heading");
                this.urlHashVal = window.location.hash;

                if (this.$accordion.length > 0) {
                  this.accordionPanelClick();
                  this.collapseAll();
                  this.expandAll();
                  if (this.urlHashVal) {
                    this.hashTrigger();
                  }
                  this.gaTracking();
                  this.legacyAccordion();
                }
              }).call(this, jQuery); 
            }
            return (
              o(e, [
                {
                  key: "filterSpecialChar",
                  value: function (t) {
                    return decodeURI(t.toLowerCase().replace(/[^a-zA-Z0-9/]/g, ""));
                  },
                },
                {
                  key: "hashTrigger",
                  value: function () {
                    var t = this,
                      e = this.filterSpecialChar(t.urlHashVal),
                      n = t.urlHashVal.replace("#", "");
                    e.length > 0 &&
                      (t.$accordion.find(".collapsing-section").each(function (e, a) {
                        $(this).attr("id") === n && $(this).parent("article").find(t.$accHeading).trigger("click");
                      }),
                      $(".qg-accordion--open").length <= 0 &&
                        t.$accordion.find(".title").each(function (n, a) {
                          t.filterSpecialChar($(a).text()) === e && $(this).parents(t.$accHeading).trigger("click");
                        }));
                  },
                },
                {
                  key: "toggleOpenCloseClass",
                  value: function (t) {
                    t.hasClass("qg-accordion--open")
                      ? (t.removeClass("qg-accordion--open").addClass("qg-accordion--closed"), t.attr("aria-expanded", "false"))
                      : (t.removeClass("qg-accordion--closed").addClass("qg-accordion--open"), t.attr("aria-expanded", "true"));
                  },
                },
                {
                  key: "accordionPanelClick",
                  value: function () {
                    var t = this;
                    t.$accordion_v2.find(t.$accHeading).on("click", function (e) {
                      t.toggleOpenCloseClass($(this));
                    });
                  },
                },
                {
                  key: "keyboardAccessibility",
                  value: function (t) {
                    if ("click" === t.type) return !0;
                    if ("keypress" !== t.type) return !1;
                    var e = t.charCode || t.keyCode;
                    return 32 === e || 13 === e || void 0;
                  },
                },
                {
                  key: "collapseAll",
                  value: function () {
                    var t = this;
                    $(".qg-acc-controls .collapse, label[for='collapse']").on("click keypress", function (e) {
                      !0 === t.keyboardAccessibility(e) &&
                        ($(this).parents(".qg-accordion").find(".acc-heading").removeClass("qg-accordion--open").addClass("qg-accordion--closed"),
                        $(this).parents(".qg-accordion").find("input:checkbox").prop("checked", !1),
                        e.preventDefault());
                    });
                  },
                },
                {
                  key: "expandAll",
                  value: function () {
                    var t = this;
                    $(".qg-acc-controls .expand, label[for='expand']").on("click keypress", function (e) {
                      !0 === t.keyboardAccessibility(e) &&
                        ($(this).parents(".qg-accordion").find(".acc-heading").removeClass("qg-accordion--closed").addClass("qg-accordion--open"),
                        $(this).parents(".qg-accordion").find("input:checkbox").prop("checked", !0),
                        e.preventDefault());
                    });
                  },
                },
                {
                  key: "gaTracking",
                  value: function () {
                    this.$accordion.find(".qg-accordion--ga").each(function () {
                      var t = "accordion title - " + $(this).find($(".title")).text();
                      $(this).attr("data-analytics-link-group", t);
                    });
                  },
                },
                {
                  key: "legacyAccordion",
                  value: function () {
                    var t = this,
                      e = $(".qg-accordion:not(.qg-accordion-v2)").find("article");
                    e.find(".acc-heading").on("keypress", function (e) {
                      if (e.target === e.currentTarget && (e.preventDefault(), !0 === t.keyboardAccessibility(e))) {
                        var n = $(this).parent();
                        n.find('input[name="tabs"]:checked').length > 0 ? n.find('input[name="tabs"]').prop("checked", !1) : n.find('input[name="tabs"]').prop("checked", !0);
                      }
                    }),
                      $("input[name=tabs]").click(function () {
                        $(this).parent("article").find(".acc-heading").focus();
                      }),
                      e.hover(
                        function () {
                          e.find(".title").removeClass("ht"), $(this).find(".title").addClass("ht");
                        },
                        function () {
                          e.find(".title").removeClass("ht");
                        }
                      );
                  },
                },
              ]),
              e
            );
          })(),
          f = new s(),
          h = (function () {
            function e() {
              t(this, e);

              (function($) {
                this.$searchWidget = $(".qg-search-widget");
                this.$inpuField = $(".qg-location-autocomplete");
                this.$inpuFieldContainer = $(".qg-fl");
                this.$latitude = $(".qg-search-widget__latitude");
                this.$longitude = $(".qg-search-widget__longitude");
                this.$form = $(".qg-search-widget-form");
                this.$getCurrentLocIcon = $(".qg-app-geocoding");

                if (this.$searchWidget.length > 0 || this.$inpuField.length > 0) {
                  this._setValFromUrlParameters();
                  this._resetValue();
                  this._keypress();
                  this._onBlue();
                  this._getCurrentLocation();
                  this._addressAutocomplete();
                }
              }).call(this, jQuery);
            }
            return (
              o(e, [
                {
                  key: "_setValFromUrlParameters",
                  value: function () {
                    this.$form
                      .find(":input:not(:checkbox):not(:radio), select, textarea")
                      .each(function () {
                        var t = $(this).attr("name"),
                          e = qg.swe.getParameterByName($(this).attr("name"));
                        e = !1 === e ? "" : $('[name="' + t + '"]').val(e);
                      })
                      .end()
                      .find("input[type=checkbox], input[type=radio]")
                      .each(function () {
                        var t = $(this).attr("name"),
                          e = qg.swe.getParameterByName(t);
                        e = !1 === e ? "" : $('[value="' + e + '"]').prop("checked", !0);
                      });
                  },
                },
                {
                  key: "_resetValue",
                  value: function () {
                    this.$searchWidget.find('button[type="reset"]').click(function (t) {
                      t.preventDefault(),
                        $(this)
                          .parent(this.$form)
                          .find(":input:not(:checkbox):not(:radio), select, textarea")
                          .each(function () {
                            $(this).val("");
                          })
                          .end()
                          .find("input[type=checkbox], input[type=radio]")
                          .each(function () {
                            $(this).prop("checked", !1);
                          });
                    });
                  },
                },
                {
                  key: "_onBlue",
                  value: function () {
                    var t = this;
                    this.$inpuField.blur(function () {
                      console.log("blur"), 0 === $(this).val().length && this.$searchWidget.find(t.$latitude).val("").end().find(t.$longitude).val("");
                    });
                  },
                },
                {
                  key: "_getCurrentLocation",
                  value: function () {
                    var t = this;
                    this.$getCurrentLocIcon.length > 0 &&
                      $.each(this.$getCurrentLocIcon, function (e, n) {
                        $(n).on("click", function (e) {
                          var n = this;
                          if ((e.preventDefault(), navigator.geolocation)) {
                            navigator.geolocation.getCurrentPosition(
                              function (e) {
                                var a = e.coords.latitude,
                                  i = e.coords.longitude,
                                  o = { lat: parseFloat(a), lng: parseFloat(i) },
                                  r = new google.maps.Geocoder(),
                                  s = $(n).parent().find(t.$inpuField);
                                t.$searchWidget.find(t.$latitude).val(a).end().find(t.$longitude).val(i),
                                  r.geocode({ location: o }, function (t, e) {
                                    "OK" === e ? (t[1] ? (s.val(t[1].formatted_address), s.trigger("place_changed")) : window.alert("No results found")) : window.alert("Geocoder failed due to: " + e);
                                  });
                              },
                              function (t) {
                                1 === t.code ? alert("Error: Access is denied!") : 2 === t.code && alert("Error: Position is unavailable!");
                              },
                              { timeout: 6e4 }
                            );
                          } else window.alert("Your browser does not support Geolocation");
                        });
                      });
                  },
                },
                {
                  key: "_addressAutocomplete",
                  value: function () {
                    var t = this;
                    f._loadGoogleApi(function () {
                      var e = new google.maps.LatLngBounds(new google.maps.LatLng(-29, 138.0578426), new google.maps.LatLng(-9.9339, 153.63831));
                      $.each(t.$inpuField, function () {
                        var n = $(this).data("strictbounds") || !0,
                          a = { bounds: e, strictBounds: n, types: ["geocode"] },
                          i = new google.maps.places.Autocomplete(this, a);
                        i.addListener("place_changed", function () {
                          var e = i.getPlace();
                          e.geometry && t.$searchWidget.find(t.$latitude).val(e.geometry.location.lat()).end().find(t.$longitude).val(e.geometry.location.lng());
                        });
                      });
                    });
                  },
                },
                {
                  key: "_keypress",
                  value: function () {
                    var t = this,
                      e = !0;
                    t.$inpuField.keypress(function (n) {
                      if ($(this).val().length >= 1 && (13 === n.keyCode || 9 === n.keyCode)) {
                        n.preventDefault();
                        var a = $(".pac-container .pac-item:first").text(),
                          i = $(".pac-container .pac-item:first .pac-item-query").text(),
                          o = i + " " + a.substring(i.length);
                        if (o.length > 1 && !0 === e)
                          t.$inpuField.val(o),
                            new google.maps.Geocoder().geocode({ address: o }, function (n, a) {
                              if ("OK" === a)
                                if (((e = !1), n)) {
                                  $(".qg-location-autocomplete").val(n[0].formatted_address);
                                  var i = n[0].geometry.location.lat(),
                                    o = n[0].geometry.location.lng();
                                  !0,
                                    t.$searchWidget.find(t.$latitude).val(i).end().find(t.$longitude).val(o),
                                    setTimeout(function () {
                                      e = !0;
                                    }, 1e3);
                                } else e = !0;
                              else (e = !0), ("ZERO_RESULTS" !== a && "OVER_QUERY_LIMIT" !== a && void 0 !== a) || console.error(a);
                            });
                      }
                    });
                  },
                },
              ]),
              e
            );
          })(),
          g = (function () {
            function e() {
              t(this, e);

              this.smBreakPoint = 992;
              this.searchStateContainer = "qg-search-state__container";

              (function($) {
                  this.$globalSearchForm = $("#qg-global-search-form");
                  this.$siteSearchInput = $(".qg-search-site__input");
                  this.$multipleForms = $(".qg-site-search__multiple-forms");
              }).call(this, jQuery);
            }
            return (
              o(e, [
                {
                  key: "init",
                  value: function () {
                    this.onResize();
                    
                    (function($) {
                      $(window).trigger("resize");
                    })(jQuery);
                  },
                },
                {
                  key: "addSearchToggleMarkup",
                  value: function () {
                    var t = this;
                    (function($) {
                        if ($("." + t.searchStateContainer).length <= 0) {
                            $('<div class="qg-search-state__container align-self-center row">' +
                                '<i class="fa fa-search" aria-hidden="true"></i>' +
                                '<p class="ml-2 mb-0">Search all information and services</p>' +
                              '</div>'
                            ).insertBefore(t.$globalSearchForm);

                            t.$globalSearchForm.hide();
                        }
                    })(jQuery);
                  },
                },
                {
                  key: "onServiceFinderSearchClick",
                  value: function () {
                    var t = this;
                    t.$multipleForms.find(t.$siteSearchInput).click(function () {
                      $(window).width() >= t.smBreakPoint && (t.$globalSearchForm.hide(), $("." + t.searchStateContainer).show());
                    });
                  },
                },
                {
                  key: "onSearchStateContainerClick",
                  value: function () {
                    var t = this;
                    (function($) {
                      $("." + t.searchStateContainer).on("click", function () {
                        $(this).hide(), t.$globalSearchForm.show("fast");
                      });
                    })(jQuery);
                  },
                },
                {
                  key: "onResize",
                  value: function () {
                    var t,
                      e = this;
                    (function($) {
                      $(window).resize(function(n) {
                          clearTimeout(t);

                          t = setTimeout(function() {
                              if ($(window).width() >= e.smBreakPoint) {
                                  e.$globalSearchForm.hide();

                                  if ($("#qg-search-query").is(":hidden")) {
                                      $("." + e.searchStateContainer).show();
                                  }

                                  e.addSearchToggleMarkup();
                                  e.onServiceFinderSearchClick();
                                  e.onSearchStateContainerClick();
                              } else {
                                  e.$globalSearchForm.removeAttr("style").removeClass("show");
                                  $("." + e.searchStateContainer).hide();
                              }
                          }, 0);
                      });
                    }).call(this, jQuery);
                  },
                },
              ]),
              e
            );
          })();
        n(962);
        !(function (t, e) {
          ({
            config: { $feedbackForm: t("#qg-page-feedback-form"), $recaptchaOnPage: t('form[data-recaptcha="true"]'), $grecaptchaBadge: t(".grecaptcha-badge"), loadedRecaptcha: !1 },
            init: function () {
              var t = this.config.$feedbackForm;
              if (t.length > 0) {
                if (!this.isProd()) {
                  var e = t.attr("action").replace("www.smartservice.qld.gov.au", "test.smartservice.qld.gov.au");
                  t.attr("action", e);
                }
                void 0 === t.attr("data-recaptcha") && t.attr("data-recaptcha", "true"), this.loadRecaptchaLib(), this.hideCaptchaBanner();
              }
            },
            isProd: function () {
              return -1 === window.location.hostname.search(/dev|test|localhost|github|\buat\b/);
            },
            googleRecaptchaApiKey: function () {
              return this.isProd() ? r.BD.W : r.BD.H;
            },
            feedbackGoogleRecaptchaApiKey: function () {
              return this.isProd() ? r.Pf.W : r.Pf.H;
            },
            footerFeedbackSubmitWithRecaptchaCheck: function () {
              var e = this;
              grecaptcha.ready(function () {
                t("#qg-page-feedback-form").submit(function (n) {
                  var a = t(this);
                  if ((n.preventDefault(), t("#qg-page-feedback-form li.invalid").length <= 0)) {
                    var i = e.config.$feedbackForm.find('input[name="g-recaptcha-response"]'),
                      o = a.attr("action"),
                      r = a.attr("method"),
                      s = t(".thankyou");
                    grecaptcha.execute(e.feedbackGoogleRecaptchaApiKey(), { action: "feedback" }).then(function (e) {
                      if (i.length > 0) {
                        i.val(e);
                        var n = a.serialize();
                        return (
                          t
                            .ajax({ url: o, type: r, data: n, contentType: "application/x-www-form-urlencoded", cache: !1, processData: !1 })
                            .done(function (e) {
                              s.removeClass("d-none"), t("#qg-page-feedback-form, .qg-feedback-toggle").addClass("d-none"), s.append(t.parseHTML(JSON.parse(e).message));
                            })
                            .fail(function () {
                              s.append("<p>Request failed, please try again</p>");
                            }),
                          !0
                        );
                      }
                    });
                  }
                });
              });
            },
            hideCaptchaBanner: function () {
              if (t("p.captchaPrivacyTerms").length === t('form[data-recaptcha="true"]').length && "hidden" !== this.config.$grecaptchaBadge.css("visibility")) {
                var e = document.createElement("style");
                (e.type = "text/css"), (e.innerText = ".grecaptcha-badge { visibility: hidden; }"), document.head.appendChild(e);
              }
            },
            v2Captcha: function (t, e, n) {
              try {
                grecaptcha.render(e, {
                  sitekey: n,
                  callback: function () {
                    var e = grecaptcha.getResponse();
                    if ("" === e || void 0 === e || 0 === e.length) return console.log("Invalid recaptcha"), !1;
                    t.submit();
                  },
                });
              } catch (t) {
                return console.log(t), grecaptcha.reset(), !1;
              }
              grecaptcha.execute();
            },
            v3Captcha: function (t, e, n, a) {
              try {
                grecaptcha.execute(n, { action: a }).then(function (n) {
                  return e.length > 0 && ("" !== e.attr("value") || 0 !== e.attr("value").length || void 0 !== e.attr("value")) && (e.val(n), t.submit(), !0);
                });
              } catch (t) {
                return console.log(t), !1;
              }
            },
            loadRecaptchaLib: function () {
              var e = this;
              t(".qg-feedback-toggle").one("click", function () {
                t.getScript("https://www.google.com/recaptcha/api.js?render=" + e.feedbackGoogleRecaptchaApiKey(), function () {
                  e.footerFeedbackSubmitWithRecaptchaCheck();
                });
              }),
                setTimeout(function () {
                  if (t("#qg-primary-content").find('form[data-recaptcha="true"]').length > 0) {
                    var n = !1;
                    t('form[data-recaptcha="true"]').each(function () {
                      var a = t(this).attr("data-sitekey"),
                        i = t(this).attr("data-action");
                      void 0 !== a && void 0 !== i
                        ? t.getScript("https://www.google.com/recaptcha/api.js?render=" + a, function () {
                            e.onloadRecaptcha();
                          })
                        : void 0 !== i
                        ? t.getScript("https://www.google.com/recaptcha/api.js?render=" + e.feedbackGoogleRecaptchaApiKey(), function () {
                            e.onloadRecaptcha();
                          })
                        : n ||
                          (t.getScript("https://www.google.com/recaptcha/api.js", function () {
                            e.onloadRecaptcha();
                          }),
                          (n = !0));
                    });
                  }
                }, 200);
            },
            onloadRecaptcha: function () {
              var e = this;
              grecaptcha.ready(function () {
                e.config.loadedRecaptcha ||
                  (t('[data-recaptcha="true"]:not(#qg-page-feedback-form)')
                    .find('input[type="submit"], button[type="submit"]')
                    .on("click", function (n) {
                      n.preventDefault();
                      var a = n.target,
                        i = t(a).parents("form"),
                        o = i.find('input[name="g-recaptcha-response"]'),
                        r = i.attr("data-sitekey"),
                        s = i.attr("data-action");
                      void 0 !== r && void 0 !== s ? e.v3Captcha(i, o, r, s) : void 0 !== s ? e.v3Captcha(i, o, e.feedbackGoogleRecaptchaApiKey(), s) : void 0 !== r ? e.v2Captcha(i, a, r) : e.v2Captcha(i, a, e.googleRecaptchaApiKey());
                    }),
                  (e.config.loadedRecaptcha = !0));
              });
            },
          }.init());
        })(jQuery, qg.swe);
        n(898), n(289), n(854), n(992), n(937);
        var p = n(848);
        n.n(p)().init(), new l().init();
        new h(), new d(), new u();
        document.querySelector(".qg-site-search__multiple-forms") && new g().init();
        n(267);
        var m = n(929),
          v = n.n(m);
        const y = { bsXs: 480, bsSm: 768, bsMd: 992, bsLg: 1200 };
        const b = {
          config: (function($) {
            return {
              $guideSubNav: $(".qg-section-nav .guide-sub-nav"),
              $qgSectionNav: $(".qg-section-nav", ".qg-section-nav"),
              $qgSectionNavListItems: $(".qg-section-nav .guide-sub-nav li"),
              $stepNav: $("#step-nav"),
              $heading: $("#qg-primary-content h1")
            };
          })(jQuery),
          init: function () {
            var t = this;
            this.config.$guideSubNav.length &&
              (this.createStepNav(),
              $(window).resize(function () {
                return t.createStepNav();
              }));
          },
          getActiveNav: function () {
            var t = 0;
            return (
              this.config.$qgSectionNavListItems.each(function (e) {
                $(this).find("a").hasClass("active") && (t = e);
              }),
              t + 1
            );
          },
          countListItems: function () {
            return this.config.$qgSectionNavListItems.length;
          },
          view: function (t, e) {
            return '<section id="step-nav">\n               <ul>\n                 <li>\n                    <a class="dropdown">Step '.concat(t, " of ").concat(e, "</a>\n                 </li>\n               </ul>\n            </section>");
          },
          createStepNav: function () {
            var t;
            if ($(window).width() < y.bsMd) {
              if (0 === $("#step-nav .guide-sub-nav").length) {
                this.config.$heading.after(this.view(this.getActiveNav(), this.countListItems()));
                var e = this.config.$guideSubNav.clone();
                $("#step-nav li").append(e);
              }
              $("#step-nav").hover(
                function () {
                  t = setTimeout(function () {
                    $("#step-nav .guide-sub-nav").stop(!0, !0).fadeIn({ duration: "100", queue: !1 }).css("display", "none").slideDown("fast");
                  }, 200);
                },
                function () {
                  clearTimeout(t), $("#step-nav .guide-sub-nav").stop(!0, !0).fadeOut({ duration: "100", queue: !1 }).slideUp("fast");
                }
              );
            } else $(document).find($("#step-nav")).remove();
          },
        };
        n(119), n(145), n(562), n(947);
        var w,
          q = n(394),
          k = n.n(q);
        n(398);
        (w = window.qg.swe.franchiseTitle),
          v().highlightNavItem(),
          b.init(),
          k().init(w),
          (function ($) {
            $("#qg-quick-exit__input").length > 0 && $("body").addClass("qg-private-content");
          })(jQuery);
      })();
  })(jQuery);
})();
